(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[92888],{

/***/ 63805:
/***/ (function(module) {

"use strict";


module.exports = isMobile
module.exports.isMobile = isMobile
module.exports["default"] = isMobile

const mobileRE = /(android|bb\d+|meego).+mobile|armv7l|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|samsungbrowser.*mobile|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i
const notMobileRE = /CrOS/

const tabletRE = /android|ipad|playbook|silk/i

function isMobile (opts) {
  if (!opts) opts = {}
  let ua = opts.ua
  if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent
  if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') {
    ua = ua.headers['user-agent']
  }
  if (typeof ua !== 'string') return false

  let result =
    (mobileRE.test(ua) && !notMobileRE.test(ua)) ||
    (!!opts.tablet && tabletRE.test(ua))

  if (
    !result &&
    opts.tablet &&
    opts.featureDetect &&
    navigator &&
    navigator.maxTouchPoints > 1 &&
    ua.indexOf('Macintosh') !== -1 &&
    ua.indexOf('Safari') !== -1
  ) {
    result = true
  }

  return result
}


/***/ }),

/***/ 91118:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(57966);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73040:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ TranslationProvider; },
/* harmony export */   "m": function() { return /* binding */ useTranslation; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _languages_tr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49323);



var TranslationContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)();
function useTranslation() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(TranslationContext);
}
function TranslationProvider(param) {
    var children = param.children, translations = param.translations;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TranslationContext.Provider, {
        value: _languages_tr__WEBPACK_IMPORTED_MODULE_2__/* .language */ .d,
        children: children
    });
}


/***/ }),

/***/ 94268:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; },
/* harmony export */   "x": function() { return /* binding */ StoreContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var StoreContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createContext(null);
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var children = param.children;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), currentRoutingTypeId = ref[0], setCurrentRoutingTypeId = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), page = ref1[0], setPage = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), mobileBar = ref2[0], setMobileBar = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), backdrop = ref3[0], setBackdrop = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), sonDakikaDates = ref4[0], setSonDakikaDates = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), favouritesIsOpen = ref5[0], setFavouritesIsOpen = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)( true ? localStorage.getItem("Favourites") ? JSON.parse(localStorage.getItem("Favourites")) : [] : 0), favourites = ref6[0], setFavourites = ref6[1];
    var context = {
        mobileBar: mobileBar,
        setMobileBar: setMobileBar,
        backdrop: backdrop,
        setBackdrop: setBackdrop,
        sonDakikaDates: sonDakikaDates,
        setSonDakikaDates: setSonDakikaDates,
        favouritesIsOpen: favouritesIsOpen,
        setFavouritesIsOpen: setFavouritesIsOpen,
        favourites: favourites,
        setFavourites: setFavourites,
        currentRoutingTypeId: currentRoutingTypeId,
        setCurrentRoutingTypeId: setCurrentRoutingTypeId,
        page: page,
        setPage: setPage
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(StoreContext.Provider, {
        value: context,
        children: children
    });
};


/***/ }),

/***/ 49323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ language; }
/* harmony export */ });
/* unused harmony export languages */
var languages = {
    tr: {
        datePickerlang: "tr",
        headerLeft: [
            // {
            //   url: "/kiralik-villa",
            //   title: "Kiralık Villa Fiyatları | Uygun Kiralık Villa Seçenekleri 2025",
            //   text: "Kiralık Villa",
            // },
            {
                url: "/2027-villalari",
                title: "2027 Villalar\u0131",
                text: "2027 Villalar\u0131"
            },
            {
                url: "/bolgeler",
                title: "B\xf6lgeler",
                text: "B\xf6lgeler"
            },
            {
                url: "/satilik-villa",
                title: "Sat\u0131l\u0131k L\xfcks Villalar - VillaVillam",
                text: "Sat\u0131l\u0131k L\xfcks Villalar"
            }, 
        ],
        reservations: {
            url: "/rezervasyonlarim",
            title: "Rezervasyonlar\u0131m",
            ariaLabel: "Kullan\u0131c\u0131 Giri\u015Fi"
        },
        blogPage: {
            url: "blog-kesfet"
        },
        searchResultSlug: "arama-sonuclari",
        menu: "Men\xfc",
        menuUpper: "MEN\xdc",
        close: "Kapat",
        closeUpper: "KAPAT",
        favourites: "Favoriler",
        searchPlaceholder: "Villa Ara",
        noResult: "Sonu\xe7 Bulunamad\u0131",
        searchMinLength: "Arama yapmak i\xe7in minumum 3 karakter giriniz",
        searchBoxTitle: "%20 \u015Eimdi, Kalan\u0131n\u0131 tatilde \xf6deme f\u0131rsat\u0131!",
        forYou: "Size \xd6zel",
        mobileSliderCaption1: "Havuzlu Kiral\u0131k Villalar",
        mobileSliderCaption1_balayi: "Havuzlu Balay\u0131 Villalar\u0131",
        mobileSliderCaption2: "Balay\u0131 Villalar\u0131",
        mobileSliderCaption3: "Muhafazakar Villalar",
        mobileSliderCaption3_balayi: "Muhafazakar Balay\u0131 Villalar\u0131",
        destination: "B\xf6lge",
        addVillaDestination: "Villan\u0131n Bulundu\u011Fu Turizm B\xf6lgesi",
        villaOptions: "Villa Se\xe7enekleri",
        checkInOutDate: "Giri\u015F - \xc7\u0131k\u0131\u015F Tarihi",
        customer: "Misafir",
        searchUpper: "ARA",
        select: "Se\xe7iniz",
        selected: "se\xe7ildi",
        adult: "Yeti\u015Fkin",
        child: "\xc7ocuk",
        informationBanner1Title: "%100 Para \u0130ade G\xfcvencesi",
        informationBanner1SubTitle: "& \xdccretsiz \u0130ptal",
        informationBanner1ButtonText: "Detayl\u0131 bilgi edin",
        documentNo: "Belge No",
        informationBanner2Title: "Villa Villam T\xdcRSAB \xfcyesi bir seyahat Acentas\u0131d\u0131r",
        informationBanner2Title_balayi: "Balay\u0131 Villas\u0131 Kirala T\xdcRSAB Seyahat Acentas\u0131d\u0131r",
        informationBanner2ButtonText: "Do\u011Frulama i\xe7in t\u0131klay\u0131n",
        informationBanner3Title: "Kredi Kart\u0131na 12 aya varan taksit imkan\u0131",
        informationBanner3ButtonText: "Detayl\u0131 bilgi edin",
        productDestinationsContainerTitle: "Kiralama B\xf6lgeleri",
        productDestinationsContainerCaption: "Hizmet verdi\u011Fimiz kiralama b\xf6lgeleri",
        productCategoriesTitle: "Villa tiplerine g\xf6zat\u0131n",
        all: "T\xfcm\xfc",
        showAll: "T\xfcm\xfcn\xfc G\xf6r\xfcnt\xfcle",
        allRentalVillas: "T\xfcm Kiral\u0131k Villalar",
        nightly: "Gecelik",
        viewDetailUpper: "DETAYLI \u0130NCELE",
        nightUpper: "GECE",
        person: "Ki\u015Fi",
        bedRoom: "Yatak Odas\u0131",
        bathRoom: "Banyo",
        villaItemPrice: "Ba\u015Flayan Fiyatlarla",
        villaItemPriceNightly: "gecelik fiyat",
        lastMinuteTitle: "Son Dakika {F\u0131rsatlar\u0131}",
        homeReviewLeftTitleSmall: "Yard\u0131ma m\u0131 ihtiyac\u0131n var?",
        homeReviewLeftTitle: "Villa Bulma Sihirbaz\u0131",
        homeReviewLeftText: "Se\xe7mekte zorlan\u0131yor musunuz? Formu doldurun, sizin i\xe7in en uygun evleri listeleyip sunal\u0131m.",
        reviews: "Misaf\u0131r Yorumlar\u0131",
        allReviews: "T\xfcm Yorumlar",
        shortTermsTitle: "K\u0131sa S\xfcreli Kiral\u0131k Villalar",
        nights: "Gece",
        faqVideoTitle: "Nas\u0131l Kiralar\u0131m ?",
        faqVideoText: "V\u0130DEO \u0130ZLE",
        footerBannerTitle: "{Size \xd6zel} havuzlu villada tatilini ba\u015Flat.",
        footerBannerCaption: "T\xfcrkiye\u2019nin mutlulu\u011Fa a\xe7\u0131lan tatil kap\u0131s\u0131ndan diledi\u011Fin villay\u0131 kolayca kirala !",
        footerPaymentLinkButtonText: "Websitemiz Kredi Kartl\u0131 <br class='lg:hidden' /> Al\u0131\u015Fveri\u015Flerde 256 Bit SSL <br /> Sertifikas\u0131 ile Korunmaktad\u0131r",
        pay: "G\xdcVENL\u0130 \xd6DE",
        copyRight: "2023 @ T\xfcm Hakk\u0131 Sakl\u0131d\u0131r. \u0130zinsiz \u0130\xe7erik Kullan\u0131lamaz.",
        wpSupport: "WhatsApp Destek",
        wpMessage: "{Villa} Hakk\u0131nda Bilgi almak istiyorum.",
        calendarUnavailable: "Dolu",
        calendarOption: "Opsiyonda",
        calendarLastMinute: "Son Dakika F\u0131rsat\u0131",
        lastMinuteBadge: "SON DAK\u0130KA",
        detailLastMinuteTitle: "Son Dakika F\u0131rsatlar\u0131",
        detailLastMinuteText: "Bu tarihlerde bo\u015F kalan g\xfcnler i\xe7in \xf6zel fiyat. F\u0131rsat, rezerve edilene kadar ge\xe7erlidir.",
        selectTheseDates: "Bu tarihleri se\xe7",
        dateSelected: "Se\xe7ildi",
        datepickerCheckIn: "Giri\u015F",
        datepickerCheckOut: "\xc7\u0131k\u0131\u015F Tarihi",
        warning: "Uyar\u0131!",
        reservationUnavailableMessage: "G\xf6r\xfcnt\xfcledi\u011Finiz  villa rezervasyon al\u0131n\u0131m\u0131na kapal\u0131d\u0131r. Dilerseniz di\u011Fer villalar\u0131m\u0131z\u0131 inceleyebilirsiniz.",
        childAge: "6-12 Ya\u015F",
        infant: "Bebek",
        infantAge: "0-5 Ya\u015F",
        back: "Geri",
        reservationSubmitButtonText: "\xdcCRETS\u0130Z REZERVASYON TALEB\u0130 G\xd6NDER",
        nameSurname: "Ad Soyad",
        email: "Email",
        phone: "Telefon",
        sendBtnText: "G\xf6nder",
        reservationSummary: "Rezervasyon \xd6zeti",
        accommodationAmount: "Konaklama Tutar\u0131 ({night} Gece) ",
        remainingAmount: "Kalan (Villaya giri\u015Fte \xf6denecek)",
        takeTotalAmount: "Al\u0131nacak Toplam Tutar",
        cleaningFee: "Temizlik \xdccreti",
        totalPrice: "Toplam Tutar",
        depositPrice: "\xd6n \xd6deme Tutar\u0131",
        watchVideo: "Videoyu \u0130zle",
        showPhotos: "Foto\u011Fraflar\u0131 G\xf6r",
        favourite: "Favori",
        share: "Payla\u015F",
        shareUpper: "PAYLA\u015E",
        morePhotos: "Foto\u011Fraf Daha",
        availabilityCalendar: "M\xfcsaitlik Takvimi",
        sidebarReservationTitle: "Rezervasyon Yap",
        sidebarReservationSubtitle: "\u015Euan bu villay\u0131 <span class='text-orange'>{count} Ki\u015Fi</span> inceliyor",
        addFavourite: "Favoriye Ekle",
        removeFavourite: "Favoriden \xc7\u0131kar",
        shareViaWhatsapp: "Whatsapp ile Payla\u015F",
        shareViaFacebook: "Facebook ile Payla\u015F",
        shareViaTwitter: "Twitter ile Payla\u015F",
        shareViaMail: "Mail ile Payla\u015F",
        copyLink: "Ba\u011Flant\u0131y\u0131 Kopyala",
        propertiesTitle: "\xd6ne \xc7\u0131kan \xd6zellikler",
        pricesTitle: "D\xf6nemlik Fiyatlar",
        inludedPrice: "Fiyata Dahil Olanlar",
        notIncludedPrice: "Fiyata Dahil Olmayanlar",
        information: "Bilgilendirme",
        cancellationTerms: "\u0130ptal \u015Eartlar\u0131",
        damageDeposit: "Hasar Depozito",
        checkinTime: "Giri\u015F Saati (En Erken)",
        checkoutTime: "\xc7\u0131k\u0131\u015F Saati (En Ge\xe7)",
        discover: "Ke\u015Ffet",
        poolDimensions: "Havuz \xd6l\xe7\xfcleri",
        poolType: "Havuz Tipi",
        childPool: "\xc7ocuk Havuzu",
        indoorPool: "Kapal\u0131 Havuz",
        distancesTitle: "Ula\u015F\u0131m Bilgisi",
        showOnMap: "Haritada G\xf6ster",
        locationInformation: "Konum Bilgisi",
        goToLocation: "Konuma git",
        detailSimilarVillasTitle: "Benzer Villalara G\xf6zat",
        favouritesRightTitle: "Favori Listesi",
        favouritesRightNotFound: "Favorilere eklenen herhangi bir villa bulunamad\u0131.",
        FavouriteItemDetailBtnText: "G\xf6r\xfcnt\xfcle",
        FavouriteItemRemoveBtnText: "Kald\u0131r",
        MenubarHomeText: "Anasayfa",
        MenubarSearchText: "Ad\u0131 ile Ara",
        MenubarButtonFilterText: "Filtrele",
        MenubarButtonReservationText: "Rezervasyon Yap",
        AllVillas: "T\xfcm Villalar",
        notDates: "Giri\u015F/\xc7\u0131k\u0131\u015F tarihlerinizi belirtiniz.",
        reservationTitle: "<strong>{baslik}</strong> i\xe7in Rezervasyon yap\u0131yorsunuz",
        reservationSection1Title: "Ki\u015Fisel Bilgilerinizi Girin",
        reservationFormNamePlaceholder: "Ad\u0131n\u0131z Soyad\u0131n\u0131z",
        reservationFormEmailPlaceholder: "E-Posta Adresiniz",
        reservationFormPhonePlaceholder: "Telefon",
        reservationFormPhonePlaceholder2: "Telefon",
        reservationSection2Title: "Onay Sonras\u0131 \xd6deme \u015Eeklinizi Se\xe7in",
        reservationPaymentAll: "Tamam\u0131",
        paymentMethod1Title: "Havale ile \xd6de",
        paymentMethod1Description: "\xd6deme tutar\u0131n\u0131 Havale veya EFT ile yapmak istiyorum.",
        paymentMethod2Title: "Kredi Kart\u0131 ile \xd6de",
        paymentMethod2Description: "\xd6demenizi kredi kart\u0131 ile tek \xe7ekim veya 12 aya kadar taksit ile yapabilirsiniz.",
        reservationSection3Title: "Villaya giri\u015Fte dikkat edilmesi gerekenler",
        reservationDamageDeposit: "Hasar Depozito",
        reservationDamageDepositDescription: "Villada herhangi bir hasar olmamas\u0131 halinde \xe7\u0131k\u0131\u015Fta iade edilecektir.",
        reservationCheckinCheckoutTime: "Giri\u015F ve \xc7\u0131k\u0131\u015F Saatleri",
        reservationCheckinTime: "Giri\u015F En Erken",
        reservationCheckoutTime: "\xc7\u0131k\u0131\u015F En Ge\xe7",
        contractText: "{contractName} okudum kabul ediyorum.",
        contract1: "Kiralama S\xf6zle\u015Fmesini",
        contract2: "KVKK Ayd\u0131nlatma Metnini",
        reservationSendValidationError: "L\xfctfen t\xfcm alanlar\u0131n ge\xe7erli oldu\u011Fundan emin olun.",
        reservationSendBtnText: "REZERVASYON TALEB\u0130 G\xd6NDER",
        reservationSuccessPageTitle: "Talep Ba\u015Far\u0131l\u0131",
        reservationSuccessPageDescription: "Rezervasyon Numaran\u0131z: <strong class='text-black font-extrabold'>{id}</strong>",
        dear: "Say\u0131n",
        reservationSuccessPageSuccessMessage: "Talebiniz ba\u015Far\u0131yla al\u0131nm\u0131\u015Ft\u0131r.",
        reservationSucessPageMailSendedMessage: "<strong class='text-black font-bold'>{mail}</strong> adresine bilgilendirme maili g\xf6nderilmi\u015Ftir.;",
        error: "Hata!",
        SearchResultTitle: "Villan\u0131 Aramaya Ba\u015Fla",
        SearchResultFilterSummeryText: "{totalRecord} Villa Listelendi",
        SearchResultFilterOrderPlaceHolder: "S\u0131ralama",
        orderOptions: [
            {
                value: "0",
                label: "Ak\u0131ll\u0131 S\u0131ralama"
            },
            // {
            //   value: "1",
            //   label: "Tarihe Göre (Önce En Eski)",
            // },
            // {
            //   value: "2",
            //   label: "Tarihe Göre (Önce En Yeni)",
            // },
            {
                value: "3",
                label: "Fiyata G\xf6re (\xd6nce En D\xfc\u015F\xfck)"
            },
            {
                value: "4",
                label: "Fiyata G\xf6re (\xd6nce En Y\xfcksek)"
            },
            {
                value: "5",
                label: "Ki\u015Fiye G\xf6re (\xd6nce En D\xfc\u015F\xfck)"
            },
            {
                value: "6",
                label: "Ki\u015Fiye G\xf6re (\xd6nce En Y\xfcksek)"
            }, 
        ],
        bankTransferFormTitle: "Havale Bildirim Formu",
        name: "Ad",
        surname: "Soyad",
        bankTransferFormAmount: "G\xf6nderilen Miktar",
        bankTransferFormDate: "G\xf6nderilen Tarih",
        bankTransferFormReceivingBank: "Al\u0131c\u0131 Banka",
        bankTransferFormMessage: "Mesaj\u0131n\u0131z",
        dateDay: "GG",
        dateMonth: "AA",
        dateYear: "YYYY",
        loginSuccess: "Giri\u015F Ba\u015Far\u0131l\u0131",
        loadingText: "Yu\u0308kleniyor",
        login: "Giri\u015F Yap",
        bankTransferNotAuth: "Havale Bildirim Formu g\xf6nderebilmek i\xe7in giri\u015F yapman\u0131z gerekiyor.",
        ProductCategoryItemSubText: "{count} villa i\xe7eriyor",
        loginLeftSubtitle: "Tekrar ho\u015Fgeldiniz,",
        loginLeftTitle: "Rezervasyon Takip",
        loginLeftCopyRight: "2021 @ T\xfcm Hakk\u0131 Sakl\u0131d\u0131r. \u0130zinsiz \u0130\xe7erik Kullan\u0131lamaz.",
        welcome: "Ho\u015Fgeldiniz",
        loginRightDescription: "E-posta adresiniz ve Rezervasyon onay numaran\u0131z ile rezervasyonlar\u0131n\u0131 bu b\xf6l\xfcmden takip yada kontrol edebilirsiniz. Rezervasyonunuz ile ilgili herhangi bir sorunla kar\u015F\u0131la\u015Ft\u0131\u011F\u0131n\u0131z takdirde m\xfc\u015Fteri hizmetlerimizle acil olarak {contact}",
        loginRightDescriptionContactLink: "ileti\u015Fime ge\xe7iniz.",
        loginFormEmail: "E-Posta Adresiniz",
        loginReservationNumber: "Rezervasyon Onay Kodu",
        loginRightDescriptionBottom: "Bu b\xf6l\xfcme giri\u015F yapabilmeniz i\xe7in, daha \xf6nceden rezervasyon yapm\u0131\u015F ve rezervasyonunuzun onaylanarak sizlere mail ve onay kodunun ula\u015Fm\u0131\u015F yada rezervasyonun kesinle\u015Fmi\u015F olmas\u0131 gerekir. Sadece talep g\xf6ndermi\u015F m\xfc\u015Fterilerimiz bu b\xf6l\xfcme ula\u015Famaz.",
        logout: "\xc7\u0131k\u0131\u015F Yap",
        reservationsTab1: "Aktif Rezervasyonlar\u0131n\u0131z",
        reservationsTab2: "Ge\xe7mi\u015F Rezervasyonlar\u0131n\u0131z",
        reservationsTab1Error: "Aktif Rezervasyon Bulunamad\u0131",
        reservationsTab2Error: "Ge\xe7mi\u015F Rezervasyon Bulunamad\u0131",
        ReservationStatus0: "Onay Bekliyor",
        ReservationStatus1: "\xd6deme Bekliyor",
        ReservationStatus1ActionBtn: "\xd6deme Bildirimi Yap",
        ReservationStatus1ActionCompleted: "\xd6deme Bildirimi Yap\u0131ld\u0131",
        ReservationStatus1ActionBtn2: "Kredi Kart\u0131 ile \xd6de",
        ReservationStatus3: "Onayland\u0131",
        ReservationStatus3Text: "\xd6dendi",
        ReservationStatus3ActionBtn: "\xd6deme Bildirimi Yap",
        ReservationStatus3ActionBtn2: "L\xfctfen Misafir bilgilerini giriniz",
        ReservationStatus3ActionBtn2Completed: "Ki\u015Fi Bilgileri Girildi",
        ReservationStatus4: "\u0130ptal Edildi",
        reservationNo: "Rez. No",
        reservationDate: "\u0130\u015Flem Tarih / Saat",
        reservationCustomerName: "M\xfc\u015Fteri Ad Soyad",
        reservationDate1: "Giri\u015F Tarihi",
        reservationDate2: "\xc7\u0131k\u0131\u015F Tarihi",
        reservationtionPrice: "\xd6deme Tutar\u0131",
        reservationGuestInformationTitle: "{reservationId}\u2019nolu Rezervasyonunuz i\xe7in {name} bilgilerinizi giriniz",
        reservationGuestInformationTitleName1: "Misafir",
        reservationGuestInformationTitleName2: "Fatura",
        reservationGuestInformationSubTitle: "En fazla {count} Ki\u015Fi konaklayabilirsiniz.",
        GuestInformationTitle: "Misafir {no} bilgileri",
        GuestInformationName: "Ad Soyad",
        GuestInformationGender: "Cinsiyet",
        GuestInformationGenderMale: "Erkek",
        GuestInformationGenderFemale: "Kad\u0131n",
        GuestInformationBirthDate: "Do\u011Fum Tarihi",
        GuestInformationBirthPlace: "Do\u011Fum Yeri",
        GuestInformationPassaport: "Pasaport No",
        GuestInformationTc: "Tc",
        GuestInformationNotTurkeyPeople: "Tc Vatanda\u015F\u0131 De\u011Filim",
        goBack: "Geri D\xf6n",
        save: "Kaydet",
        GuestInformationInvoiceType: "Fatura Tipi",
        GuestInformationInvoiceTypeOption1: "Bireysel",
        GuestInformationInvoiceTypeOption2: "Kurumsal",
        GuestInformationInvoiceTypeOption1Name: "Ad Soyad",
        GuestInformationInvoiceTypeOption2Name: "\u015Eirket Ad\u0131",
        GuestInformationInvoiceTaxOffice: "Vergi Dairesi",
        GuestInformationInvoiceTaxNumber: "Vergi Numaras\u0131",
        address: "Adres",
        GuestInformationSuccessfullyTitle: "Misafir Bilgileri Ba\u015Far\u0131yla Al\u0131nd\u0131",
        GuestInformationSuccessfullyDescription: "Misafir bilgilerinizin \xf6zeti size e-posta ile g\xf6nderildi. E\u011Fer bir hata oldu\u011Funu d\xfc\u015F\xfcn\xfcyorsan\u0131z l\xfctfen M\xfc\u015Fteri Hizmetlerimizle ileti\u015Fime ge\xe7in.",
        PayByCreditCardTitle: "{price} \xf6demeyi",
        PayByCreditCardCaption: "Banka veya Kredi Kart\u0131 ile \xd6de",
        PayByCreditCardFormName: "Ad Soyad",
        PayByCreditCardFormCardNumber: "Kart \xfczerindeki 12 haneli numara",
        PayByCreditCardFormSubmit: "\xd6de",
        PayByCreditCardRightTitle: "{night} Gece Konaklama",
        PaymentAuthRequired: "\xd6deme yapmak i\xe7in giri\u015F yapman\u0131z gerekiyor.",
        installementFull: "Tek \xc7ekim",
        installement: "Taksit",
        paymentSuccess: "\xd6deme Ba\u015Far\u0131l\u0131",
        paymentSuccessDescription: "Bu pencereyi kapatabilirsiniz.",
        paymentTryAgain: "L\xfctfen Tekrar Deneyiniz",
        getOfferStep1Title1: "Villa bulma sihirbaz\u0131na",
        getOfferStep1Title2: "Ho\u015Fgeldiniz",
        getOfferStep1Caption1: "Arad\u0131\u011F\u0131n villay\u0131",
        getOfferStep1Caption2: "bulmakta zorlan\u0131yor musun ?",
        getOfferStep1SubTitle: "Sadece 5 ad\u0131mda arad\u0131\u011F\u0131n villay\u0131 kolayca bul",
        getOfferNextBtn: "Sonraki",
        getOfferPrevBtn: "\xd6nceki",
        getOfferSendBtn: "Formu G\xf6nder",
        getOfferStep2Title: "NASIL B\u0130R V\u0130LLADA TAT\u0130L YAPMAK \u0130STERS\u0130N\u0130Z",
        getOfferStep2Option1: "EKONOM\u0130K",
        getOfferStep2Option2: "ORTA",
        getOfferStep2Option3: "L\xdcKS",
        getOfferStep3Title: "TAT\u0130L\u0130N\u0130Z\u0130 NE \u0130\xc7\u0130N PLANLIYORSUNUZ ?",
        getOfferStep3Option1: "Balay\u0131 veya \xd6zel G\xfcn",
        getOfferStep3Option2: "Aile veya Arkada\u015Flarla",
        getOfferStep4Title: "V\u0130LLANIZDA OLMASINI \u0130STED\u0130\u011E\u0130N\u0130Z \xd6ZELL\u0130KLER",
        getOfferStep5Title: "B\u0130LG\u0130LER\u0130N\u0130Z",
        getOfferFormFullName: "Ad Soyad",
        getOfferFormEmail: "Email Adresiniz",
        getOfferFormPhone: "Telefon Numaram\u0131z",
        getOfferFormPerson: "Ki\u015Fi Say\u0131s\u0131",
        getOfferFormAdult: "Yeti\u015Fkin",
        getOfferFormChild: "\xc7ocuk",
        getOfferFormInfant: "Bebek",
        getOfferFormError: "Bir sorun olu\u015Ftu",
        getOfferModalTitle: "TE\u015EEKK\xdcRLER",
        getOfferModalCaption: "Villa bulma sihirbaz\u0131 size en uygun olan se\xe7enekleri bulmak i\xe7in \xe7al\u0131\u015Fmaya ba\u015Flad\u0131",
        getOfferModalDescription: "En k\u0131sa zamanda sizin i\xe7in se\xe7ilen villalar sms ve email olarak g\xf6nderilecektir",
        blogSidebarSearchTitle: "Arama Yap\u0131n",
        blogSidebarSearchPlaceHolder: "Blog Ara",
        blogSidebarList1Title: "Son Yaz\u0131lar",
        blogSidebarList2Title: "Pop\xfcler Yaz\u0131lar",
        blogItemReadBtn: "Devam\u0131n\u0131 Oku",
        bankItemBankName: "Banka Ad\u0131",
        bankItemBankBranch: "\u015Eube Ad\u0131-Kodu",
        bankItemBankAccountName: "Hesap Ad\u0131",
        bankItemBankIban: "\u0130ban No",
        checkinInformationTitle: "Rezervasyon detaylar\u0131n\u0131z",
        viewInvoice: "Fatura Bilgilerini G\xf6r",
        viewContract: "S\xf6zle\u015Fme Bilgilerini G\xf6r",
        customerInformations: "M\xfc\u015Fteri Bilgileri",
        villaManager: "Villa Sorumlusu/G\xf6revlisi",
        callNow: "Hemen Ara",
        sendMessageViaWp: "Whatsapp\u2019dan yaz",
        earliest: "En Erken",
        latest: "En Ge\xe7",
        paymentInformations: "\xd6deme Bilgileri",
        paymentOwnerInformation: "\xd6deme Bilgileri Detay\u0131",
        remaining: "Kalan",
        accommodationPrice: "Toplam Konaklama Tutar\u0131",
        paymentCheckin: "Villaya Giri\u015Fte Yap\u0131lmas\u0131 Gereken \xd6deme",
        creditcardNotAccepted: "(Kredi kart\u0131 ge\xe7erli <span class='underline'>de\u011Fildir</span>)",
        entranceInformationDamageDeposit: "Ayr\u0131ca {hasar} de\u011Ferinde hasar depozitosu al\u0131nacakt\u0131r.",
        entranceInformationLocationErrorOwner: "L\xfctfen Misafiriniz ile irtibata ge\xe7ip konum bilgisi iletiniz!",
        entranceInformationLocationErrorCustomer: "L\xfctfen Villa Sorumlusu/G\xf6revlisi ile irtibata ge\xe7ip konum bilgisi isteyiniz !",
        UnconditionalmoneyTitle: "24 Saat \u0130\xe7erisinde",
        UnconditionalmoneySubTitle: "Ko\u015Fulsuz Para \u0130adesi",
        UnconditionalmoneyDescription: "*Rezervasyonun onaylanmas\u0131n\u0131 takip eden 24 saat i\xe7erisinde \u0130PTAL ger\xe7ekle\u015Firse ziyaret\xe7i \xf6demi\u015F oldu\u011Fu kaporay\u0131 ko\u015Fulsuz iade al\u0131r.",
        UnconditionalmoneyDescription2: "Giri\u015F tarihi en erken 21 g\xfcn i\xe7erisindeki olan rezervasyonlarda ge\xe7erli de\u011Fildir.",
        discount: "\u0130ndirim",
        discountedAccommodationAmount: "\u0130ndirimli Konaklama Tutar\u0131",
        appliedDiscount: "{code} kodu uyguland\u0131",
        ihaveapromotioncode: "Promosyon Kodum Var",
        promotionCode: "Promosyon Kodu",
        apply: "Uygula",
        callCenterName: "M\xfc\u015Fteri Hizmetleri",
        allVillasCta: "T\xfcm kiral\u0131k villalar",
        allVillasCtaSub: "Tarih se\xe7meden t\xfcm villalara g\xf6z at\u0131n",
        allVillasCtaStrip: "Tarih se\xe7meden t\xfcm kiral\u0131k villalara g\xf6z at\u0131n",
        allVillasCtaRest: "ve di\u011Fer t\xfcm b\xf6lgeler",
        disableCalendarRules: "Takvim Kurallar\u0131na Uyma",
        roomCount: "Oda Say\u0131s\u0131",
        paybackDamageInfo: "Giri\u015Fte al\u0131nacak, hasar olmamas\u0131 durumunda \xe7\u0131k\u0131\u015Fta taraf\u0131n\u0131za iade edilecektir.",
        paymentByCompany: "Acenta taraf\u0131ndan g\xf6nderilecek tutar",
        paymentByCompanyInfo: "Giri\u015F tarihinden sonraki 1-5 i\u015F g\xfcn\xfc i\xe7erisinde hesab\u0131n\u0131za g\xf6nderilecektir.",
        accountDelete: "Hesab\u0131m\u0131 Sil",
        rezervationCode: "Rezervasyon Kodu",
        memberLogin: "\xdcye Giri\u015Fi",
        noAccount: "Hesab\u0131n\u0131z yok mu?",
        register: "Kaydol",
        forgotPassword: "\u015Eifremi Unuttum",
        loginError: "Giri\u015F yap\u0131l\u0131rken bir hata olu\u015Ftu.",
        newPassword: "Yeni \u015Eifre",
        confirmPassword: "\u015Eifre Tekrar\u0131",
        updatePassword: "\u015Eifreyi G\xfcncelle",
        otpCode: "Do\u011Frulama Kodu",
        verifyCode: "Kodu Do\u011Frula",
        resendCode: "Kodu Tekrar G\xf6nder",
        otpRequired: "Do\u011Frulama kodu zorunludur",
        otpLength: "Kod 6 haneli olmal\u0131d\u0131r",
        otpError: "Kod do\u011Frulanamad\u0131.",
        otpResendSuccess: "Do\u011Frulama kodu tekrar g\xf6nderildi.",
        otpResendError: "Kod tekrar g\xf6nderilemedi.",
        passwordRequired: "\u015Eifre zorunludur",
        passwordMin: "\u015Eifre en az 6 karakter olmal\u0131d\u0131r",
        passwordsNotMatch: "\u015Eifreler e\u015Fle\u015Fmiyor",
        passwordUpdateSuccess: "\u015Eifreniz ba\u015Far\u0131yla g\xfcncellendi!",
        passwordUpdateError: "\u015Eifre g\xfcncellenemedi.",
        completeRegistration: "Kayd\u0131 Tamamla",
        nameRequired: "Ad zorunludur",
        surnameRequired: "Soyad zorunludur",
        emailRequired: "E-posta zorunludur",
        emailInvalid: "Ge\xe7erli bir e-posta giriniz",
        registrationSuccess: "Hesab\u0131n\u0131z olu\u015Fturuldu!",
        registrationError: "Kay\u0131t tamamlanamad\u0131.",
        password: "\u015Eifre",
        sendResetCode: "S\u0131f\u0131rlama Kodu G\xf6nder",
        backToLogin: "Giri\u015F Yap'a D\xf6n",
        createNewPassword: "Yeni \u015Eifre Olu\u015Ftur",
        continue: "Devam Et",
        phoneRequired: "Telefon numaras\u0131 zorunludur",
        phoneInvalid: "Ge\xe7erli bir numara giriniz",
        operationFailed: "\u0130\u015Flem ba\u015Far\u0131s\u0131z.",
        newPasswordRequired: "Yeni \u015Fifre zorunludur",
        confirmPasswordRequired: "\u015Eifre tekrar\u0131 zorunludur",
        // --- Yeni metinler (site 2 ceviri) ---
        faqTitle: "S\u0131k\xe7a Sorulan Sorular",
        instagramSubtitle: "Kiral\u0131k Tatil Villalar\u0131",
        instagramText: "Fethiye ve \xe7evresindeki en \xf6zel villalar\u0131 ke\u015Ffetmek, misafir deneyimlerimizi g\xf6rmek i\xe7in bizi takip edin.",
        instagramFollow: "Instagram'da Takip Et",
        discountedBadge: "\u0130ndirimli",
        instantBooking: "An\u0131nda Rezervasyon",
        googleReviewsTitle: "Google Misafir Yorumlar\u0131",
        googleReviewsCount: "1.179 Ger\xe7ek Yorum",
        viewAllReviews: "T\xfcm yorumlar\u0131 g\xf6r\xfcnt\xfcle",
        excellent: "M\xfckemmel",
        weekly: "Haftal\u0131k",
        workingHours: "\xc7al\u0131\u015Fma Saatleri",
        noResultFound: "Sonu\xe7 Bulunamad\u0131",
        mobileMenuLabel: "Mobil Men\xfc",
        copied: "Kopyaland\u0131!",
        reviewCtaTitle: "Misafirimiz Oldunuz Mu?",
        reviewCtaThisVilla: "Bu villadaki",
        reviewCtaText: "tatiliniz nas\u0131ld\u0131? Deneyiminizi bizimle ve di\u011Fer misafirlerle payla\u015Farak onlara da yol g\xf6sterebilirsiniz.",
        ministryOfTourism: "T.C K\xfclt\xfcr ve Turizm Bakanl\u0131\u011F\u0131",
        applicationNo: " Ba\u015Fvuru No: ",
        applicationInProgress: " Ba\u015Fvuru S\xfcrecinde",
        cancel: "\u0130ptal",
        clearSelection: "Se\xe7imi kald\u0131r",
        sidebarPayNowText: "\xd6n onay beklemeden \xf6demenizi yap\u0131n ve rezervasyonunuzu tamamlay\u0131n.",
        bedroom1: "Yatak Odas\u0131 1",
        bedroom2: "Yatak Odas\u0131 2",
        garden: "Bah\xe7e",
        doubleBed: "\xc7ift Ki\u015Filik Yatak",
        bathroomDoubleBed: "Banyo \xc7ift Ki\u015Filik Yatak",
        poolLength: "Boy",
        poolWidth: "En",
        poolDepth: "Derinlik",
        directionsAria: "Ofis konumumuz i\xe7in yol tarifi al",
        timeAlmostUp: "S\xfcre Dolmak \xdczere!",
        paymentTime: "\xd6deme S\xfcresi",
        timeLeftToComplete: "Rezervasyonunuzu tamamlamak i\xe7in kalan zaman",
        dayShort: "G\xfcn",
        feedbackThanks: "Geri bildiriminiz i\xe7in te\u015Fekk\xfcr ederiz...",
        feedbackChooseRating: "L\xfctfen ge\xe7erli bir puan se\xe7iniz.",
        feedbackAsk: "Web sitemiz yenilendi, yeni web sitemizi de\u011Ferlendirmek ister misiniz?",
        no: "Hay\u0131r",
        yourRating: "Puan\u0131n\u0131z",
        pleaseSelect: "Se\xe7iniz",
        certificateLabel: "Belge",
        certificateNo: " No : ",
        rentableNow: "Hemen Kiralanabilir",
        errorTitle: "Hata",
        warningTitle: "Uyar\u0131",
        attention: "Dikkat",
        hoursLabel: "Saat",
        minutesLabel: "Dakika",
        secondsLabel: "Saniye",
        followUs: "Takipte Kal",
        ourOffice: "Ofisimiz",
        getDirections: "Yol Tarifi Al",
        footerAddress: "Akarca Mah. Adnan Menderes Bulvar\u0131 No:205/C 1-2-3 Fethiye/Mu\u011Fla",
        learnMore: "Bilgi al",
        favouritesAria: "Favoriler",
        favouriteAria: "Favori",
        writeReviewShort: "Yorum Yaz",
        googleWriteReview: "Google'da Yorum Yap",
        nightLabel: "Gece",
        moreInfo: "Detayl\u0131 Bilgi",
        free: "\xdccretsiz",
        dateLabel: "Tarih",
        amountLabel: "Tutar",
        statusLabel: "Durum",
        feeLabel: "\xdccret",
        statusAvailable: "Mevcut",
        statusUnavailable: "Devred\u0131\u015F\u0131",
        serviceFreePre: "Kullan\u0131labilir tarihler i\xe7in bu hizmetten",
        serviceFreeStrong: "\xdccretsiz",
        serviceFreePost: "faydalanabilirsiniz. \u263A\uFE0F",
        servicePaidPre: "Kullan\u0131labilir tarihler i\xe7in toplam",
        servicePaidPost: "\xfccret al\u0131nacakt\u0131r.",
        mobileAppDiscount: "Mobil uygulamaya \xf6zel indirim",
        promoCodeDiscount: "Promosyon Kodu \u0130ndirimi",
        heatedPool: "Is\u0131tmal\u0131 Havuz",
        optionalServices: "Opsiyonel Hizmetler",
        heatingPoolTitle: "Is\u0131tma Havuzu \xdccretleri ve Kullan\u0131labilirlik Durumu",
        notUsable: "Kullan\u0131lamaz",
        usable: "Kullan\u0131labilir",
        closeBtn: "Kapat",
        wantHeatedPool: "Is\u0131tmal\u0131 havuzdan faydalanmak istiyorum",
        heatedPoolDatesPre: "Is\u0131tma Hizmeti alabilece\u011Finiz tarihleri g\xf6rmek i\xe7in",
        heatedPoolDatesClick: "t\u0131klay\u0131n\u0131z",
        availableDatesText: "Bu tesis i\xe7in rezervasyon yap\u0131labilir uygun tarihler",
        selectBtn: "Se\xe7",
        loadingDots: "Y\xfckleniyor...",
        continueAnyway: "Yine de Devam Et",
        availableDatesWarning: "Genellikle olumsuz sonu\xe7lanmaktad\u0131r. Ama dilerseniz sizler i\xe7in tekrar de\u011Ferlendirebiliriz veya alternatif tarihlerden se\xe7im yapabilirsiniz.",
        payNow: "\u015Eimdi \xf6de",
        contactAddress: "Adres",
        contactPhoneEmail: "Telefon & Email",
        contactShare: "Payla\u015F",
        contactForm: "\u0130leti\u015Fim Formu",
        contactFullName: "Ad\u0131n\u0131z Soyad\u0131n\u0131z",
        contactPhone: "Telefon Numaran\u0131z",
        contactEmail: "Email Adresiniz",
        contactSubject: "Konu",
        contactMessage: "Mesaj\u0131n\u0131z",
        contactSecurityCode: "G\xfcvenlik Kodu",
        contactSecurityCodeEnter: "G\xfcvenlik Kodunu Giriniz",
        contactSendForm: "FORMU G\xd6NDER",
        contactMap: "Harita",
        creditCardInstantNote: "Kredi kart\u0131 ile \xf6deme y\xf6ntemini tercih etti\u011Finizde, rezervasyonunuz onay s\xfcrecine gerek kalmadan an\u0131nda tamamlanacak ve kesinle\u015Fecektir.",
        cardNumberLength: "Kart numaras\u0131 12 haneli olmal\u0131d\u0131r.",
        paymentStatusChecking: "\xd6deme durumu kontrol ediliyor...",
        paymentSuccessToast: "\xd6deme Ba\u015Far\u0131l\u0131",
        closeWindowAfterPayment: "\xd6demenizi yapt\u0131ktan sonra bu pencereyi kapatabilirsiniz.",
        clickToPay: "\xd6deme Yapmak \u0130\xe7in T\u0131klay\u0131n\u0131z",
        installments369: "T\xfcm banka kartlar\u0131na 3-6-9 taksit imkan\u0131",
        bankRatesApply: "Bankalar\u0131n belirtmi\u015F oldu\u011Fu oranlar ge\xe7erlidir",
        successTitle: "Ba\u015Far\u0131l\u0131",
        paymentReceived: "\xd6demeniz ba\u015Far\u0131yla al\u0131nm\u0131\u015Ft\u0131r.",
        paymentInfoSentTo: "adresine \xf6deme bilgileri g\xf6nderilmi\u015Ftir.",
        contactAndPaymentInfo: "\u0130leti\u015Fim ve \xd6deme Bilgileri",
        fullNameLabel: "\u0130sim Soyisim",
        creditCardInfo: "Kredi Kart\u0131 Bilgileri",
        cardNumberLabel: "Kart Numaras\u0131",
        loadingShort: "Y\xfckleniyor",
        payBtn: "\xd6deme Yap",
        sslNotice: "{domain} \xfczerinden yapacak oldu\u011Funuz \xf6deme i\u015Flemleri 256-Bit SSL Sertifikas\u0131 ile \u015Fifrelenerek banka taraf\u0131na iletilir. Bankan\u0131z ile {site} aras\u0131nda g\xfcvenli olarak bilgi ak\u0131\u015F\u0131 sa\u011Flan\u0131r ve kart bilgileriniz hi\xe7bir veritaban\u0131na kaydedilmez.",
        heatedPoolFee: "Is\u0131tmal\u0131 Havuz \xdccreti",
        sliderCaptionDefault: "Size \xf6zel havuzlu villada tatilini ba\u015Flat",
        ownerWelcomeBack: "Tekrar ho\u015Fgeldiniz,",
        ownerPanelTitle: "Ev Sahibi Y\xf6netim Paneli",
        ownerCopyright: "2021 @ T\xfcm Hakk\u0131 Sakl\u0131d\u0131r. \u0130zinsiz \u0130\xe7erik Kullan\u0131lamaz.",
        ownerWelcome: "Ho\u015Fgeldiniz.",
        ownerIntroPre: "Size verilen E-posta adresi ve \u015Fifre ile evlerinizi bu b\xf6l\xfcmden takip yada kontrol edebilirsiniz. Evleriniz ile ilgili herhangi bir sorunla kar\u015F\u0131la\u015Ft\u0131\u011F\u0131n\u0131z takdirde m\xfc\u015Fteri hizmetlerimizle acil olarak",
        ownerIntroLink: "ileti\u015Fime ge\xe7iniz.",
        ownerLoginError: "Kullan\u0131c\u0131 ad\u0131 veya \u015Fifre hatal\u0131.",
        usernameLabel: "Kullan\u0131c\u0131 Ad\u0131",
        passwordLabel2: "\u015Eifre",
        loginBtn2: "Giri\u015F Yap",
        advertiseQPre: "",
        advertiseQStrong: "Villa ",
        advertiseQPost: "Sahibi Misiniz ?",
        advertiseFormReceived: "Formunuz al\u0131nm\u0131\u015Ft\u0131r. \u0130lgili departman\u0131m\u0131z en k\u0131sa s\xfcrede d\xf6n\xfc\u015F sa\u011Flayacakt\u0131r. \u0130lginize te\u015Fekk\xfcr ederiz.",
        poolPrivate: "\xd6zel Havuz",
        poolShared: "Ortak Havuz",
        poolNone: "Havuz Yok",
        seaViewLabel: "Deniz Manzaras\u0131",
        yesLabel: "Var",
        noLabel: "Yok",
        yourMessagePlaceholder: "Mesaj\u0131\u0131n\u0131z",
        advInfo1Title: "DO\u011ERU F\u0130YAT VE KAZAN\xc7 BEL\u0130RLEME ",
        advInfo1Text: "Villan\u0131z\u0131n \xf6zellikleri, kapasitesi, konumu gibi kriterleri g\xf6z \xf6n\xfcnde bulundurarak muadilleriyle k\u0131yaslar; en isabetli fiyatland\u0131rma \xe7al\u0131\u015Fmas\u0131n\u0131 yaparak sezonluk kazan\xe7 senaryosunu da detayland\u0131rabiliriz.",
        advInfo2Title: "PROF\u0130L VE \u0130LAN Y\xd6NET\u0130M\u0130 ",
        advInfo2Text: "Villan\u0131z\u0131 uzman ekibimizle birlikte isabetli reklam \xe7al\u0131\u015Fmalar\u0131 yaparak do\u011Fru misafir kitlesine sunar\u0131z. Etkili sosyal medya y\xf6netimi bilinci ve deneyimi ile en y\xfcksek dolulu\u011Fa ula\u015Fman\u0131z i\xe7in titizlikle \xe7al\u0131\u015Fmaktay\u0131z.",
        advInfo3Title: "7/24 M\u0130SAF\u0130R DESTEK HATTI ",
        advInfo3Text: "7 G\xfcn / 24 Saat Call Center hizmeti ile misafirlerimizin talep ve sorular\u0131na an\u0131nda d\xf6n\xfc\u015F sa\u011Flamaktay\u0131z. G\xfcn ve saat farketmeksizin s\xfcrekli destek hatt\u0131 ile hizmet vermekteyiz.",
        advInfo4Title: "PROFESYONEL FOTO\u011ERAF & V\u0130DEO \xc7EK\u0130MLER\u0130 ",
        advInfo4Text: "Villa tan\u0131t\u0131m\u0131nda en \xf6nemli fakt\xf6rlerden birisi olan foto\u011Frafland\u0131rma i\u015Flemini profesyonel ekibimiz ile sa\u011Flamaktay\u0131z. \xc7ekimlerimiz reklam \xe7al\u0131\u015Fmalar\u0131 ve sosyal medya hesaplar\u0131nda etkin kullan\u0131ma uygun y\xf6ntemler dikkate al\u0131narak titizlikle yap\u0131lmaktad\u0131r.",
        advInfo5Title: "DE\u011EERLEND\u0130RME VE B\u0130LG\u0130LEND\u0130RME",
        advInfo5Text: "Villan\u0131z\u0131n maksimum dolulu\u011Fa ula\u015Fmas\u0131 amac\u0131yla projenizin ba\u015F\u0131ndan sonuna kadar deneyimli kadromuzdan i\xe7 ve d\u0131\u015F mekan dizayn\u0131, donan\u0131msal \xf6zelliklerin katk\u0131lar\u0131 gibi konularda de\u011Ferlendirme ve detayl\u0131 bilgi edinebilir, bu sayede daha y\xfcksek rezervasyon talebi alabilirsiniz.",
        ptdTitle1: "Kap\u0131da",
        ptdTitle2: "\xd6deme",
        ptdTitle3: "Sistemi",
        ptdP1: "rezervasyon a\u015Famas\u0131nda villaya g\xf6re %15 ile %40 aras\u0131nda \xd6N \xd6DEME talep etmektedir.",
        ptdP2: "Kalan \xf6demenizi Villa\u2019ya giri\u015F g\xfcn\xfc Villa Sahibine \xf6deme yapabilirsiniz.",
        ptdP3: "Villa sahibinin KALAN \xd6demenizi nas\u0131l talep etti\u011Fi rezervasyon a\u015Famas\u0131nda size gelen MA\u0130L i\xe7erisinde belirtilmektedir.",
        refundTitle1: "Villa Sahibi Kaynakl\u0131 Problemlerde",
        refundTitle2: "%100 Para \u0130adesi",
        refundP1Pre: "Tatiliniz i\xe7in rezerve etti\u011Finiz villa\u2019ya giri\u015F saatinizden itibaren 6 saat i\xe7erisinde villa sahibine ula\u015Famaman\u0131z veya g\xf6rsellerde g\xf6rd\xfc\u011F\xfcn\xfcz villan\u0131n farkl\u0131 olmas\u0131 durumunda ( mobilya ve dekorasyon de\u011Fi\u015Fiklikleri d\u0131\u015F\u0131nda ) ge\xe7erlidir. \xd6demi\u015F oldu\u011Funuz t\xfcm tutar size",
        refundP1Strong: "geri iade",
        refundP1Post: "edilir.",
        refundP2: "ya\u015Fanan bu ma\u011Fduriyeti gidermek ad\u0131na ayn\u0131 b\xf6lgede tatilinize devam edebilmeniz i\xe7in m\xfcsait olan villalarda komisyon kazanc\u0131 yok say\u0131larak indirimli bir \u015Fekilde size Sat\u0131\u015F Dan\u0131\u015Fman\u0131 arkada\u015Flar\u0131m\u0131z yard\u0131mc\u0131 olmaktad\u0131r.",
        refundP3: "Bu durumlar\u0131n haricinde tatil esnas\u0131nda ya\u015Fayabilece\u011Finiz sorunlarda {site} yine sizlere ya\u015Fanan sorunun en h\u0131zl\u0131 \u015Fekilde \xe7\xf6z\xfclmesinde sorunun \xe7\xf6z\xfclemeyecek bir hal ald\u0131\u011F\u0131 durumlarda farkl\u0131 bir villada m\xfcsaitlik olmas\u0131 durumunda ge\xe7i\u015Finizin sa\u011Flanmas\u0131 ad\u0131na yard\u0131mc\u0131 olmaktad\u0131r",
        securaTitle1: "G\xfcvenli",
        securaTitle2: "\xd6deme",
        securaTitle3: "Sistemi",
        securaP1Pre: "Bir",
        securaP1Company: "Co\u015Fkunlar Ticaret Emlak Turizm \u0130n\u015Faat Limited \u015Eirketi",
        securaP1Post: "Kurulu\u015Fudur.",
        securaP2: "Sitemizde SSL protokol\xfc \u015Fifreleme sistemi (\xe7\xf6z\xfclmesi imkans\u0131z), 256 Bit secure site ile 3D Secure \xf6deme sistemi kullan\u0131lmaktad\u0131r.",
        securaP3: "Sanal Pos Sistemi \xdczerinden Kredi Kart\u0131n\u0131zla veya Resmi \u015Eirket Hesaplar\u0131m\u0131za Havale/Eft Yapabilirsiniz.",
        securaPolicyTitle: "\u0130\u015Fbu Gizlilik Politikas\u0131:",
        securaPolicyText: "{domain} adresini ziyaret eden ve kullanan t\xfcm kullan\u0131c\u0131lar\u0131 kapsamakta olup; pe\u015Finen kabul edilmi\u015Ftir. {domain} yi kullanan ziyaret\xe7ilerin do\u011Frudan ve/veya dolayl\u0131 olarak bizlere sundu\u011Fu verilerden a\u015Fa\u011F\u0131da bahsedilmi\u015Ftir. Bu veriler, Kiralama ve Kullan\u0131m s\xf6zle\u015Fmesi, Gizlilik Politikas\u0131 \u015Fartlar\u0131 gere\u011Fi uygun olan haller dahilinde kullan\u0131lmakta olup; bu uygun olan hallerin d\u0131\u015F\u0131nda kullan\u0131lmamaktad\u0131r.",
        installPre: "Rezervasyonunuzu \u015Fimdi yap\u0131n,",
        installMid: "kredi kart\u0131na taksit imkan\u0131yla rahat rahat \xf6deyin. {site} t\xfcm kredi kartlar\u0131na 12 aya varan taksit imkan\u0131 sunmaktad\u0131r.",
        installNote: "Taksit se\xe7eneklerinde vade fark\u0131 oranlar\u0131 kulland\u0131\u011F\u0131n\u0131z banka taraf\u0131ndan belirlenmektedir. Rezervasyon i\u015Fleminizden \xf6nce ilgili bankan\u0131n uygulad\u0131\u011F\u0131 vade fark\u0131 oranlar\u0131n\u0131 inceleyebilir, taksit imkan\u0131ndan yararlanabilirsiniz.",
        installUpTo: "12 aya varan taksit imkan\u0131",
        installTursab: "{site} Turizm Seyahat Acentas\u0131 T\xdcRSAB A-14264 Belge ile T.C Turizm Bakanl\u0131\u011F\u0131na ba\u011Fl\u0131d\u0131r.",
        paidAccommodationAmount: "\xd6denen Konaklama Tutar\u0131",
        remainingAccommodationAmount: "Kalan Konaklama Tutar\u0131"
    },
    en: {
        datePickerlang: "en-US",
        headerLeft: [
            {
                url: "/villa-for-rent",
                title: "Villa for Rent",
                text: "Villa for Rent"
            },
            {
                url: "/2027-villas",
                title: "2027 Villas",
                text: "2027 Villas"
            },
            {
                url: "/regions",
                title: "Rental Regions",
                text: "Regions"
            }, 
        ],
        reservations: {
            url: "/my-reservations",
            title: "My Reservations",
            ariaLabel: "My Reservations"
        },
        blogPage: {
            url: "blog-discover"
        },
        searchResultSlug: "search-result",
        menu: "Menu",
        menuUpper: "MENU",
        close: "Close",
        closeUpper: "CLOSE",
        favourites: "Favourites",
        searchPlaceholder: "Search Villa",
        noResult: "No Result",
        searchMinLength: "Enter minimum 3 characters to search",
        searchBoxTitle: "Pay the remaining part of your vacation later!",
        forYou: "For You",
        mobileSliderCaption1: "Villas with Pool",
        mobileSliderCaption2: "Honeymoon Villas",
        mobileSliderCaption3: "Conservative Villas",
        destination: "Destination",
        addVillaDestination: "Location",
        villaOptions: "Villa Options",
        checkInOutDate: "Dates",
        customer: "Guests",
        searchUpper: "SEARCH",
        select: "Select",
        selected: "selected",
        adult: "Adult",
        child: "Child",
        informationBanner1Title: "100% Money Back Assurance",
        informationBanner1SubTitle: "& Free Cancellation",
        informationBanner1ButtonText: "View Details",
        documentNo: "Document No.",
        informationBanner2Title: "Villa Villam is a member travel agency of T\xdcRSAB",
        informationBanner2ButtonText: "Click for verification",
        informationBanner3Title: "Up to 12 monthly installments by credit card",
        informationBanner3ButtonText: "View Details",
        productDestinationsContainerTitle: "Rental Regions",
        productDestinationsContainerCaption: "Rental areas we serve",
        productCategoriesTitle: "Browse villa types",
        all: "All",
        showAll: "View All",
        allRentalVillas: "All Rental Villas",
        nightly: "Night",
        viewDetailUpper: "VIEW DETAILS",
        nightUpper: "NIGHT",
        person: "Person",
        bedRoom: "Bedroom",
        bathRoom: "Bathroom",
        villaItemPrice: "Cheapest",
        villaItemPriceNightly: "nightly",
        lastMinuteTitle: "Last Minute {Deals}",
        homeReviewLeftTitleSmall: "Do you need help?",
        homeReviewLeftTitle: "Villa Finding Wizard",
        homeReviewLeftText: "Having trouble choosing? Fill out the form and we will list and present the most suitable houses for you.",
        reviews: "Guest Comments",
        allReviews: "All Comments",
        shortTermsTitle: "Short Terms Rental Villas",
        nights: "Nights",
        faqVideoTitle: "How do I rent?",
        faqVideoText: "WATCH VIDEO",
        footerBannerTitle: "{Start} your vacation in a villa with a private pool.",
        footerBannerCaption: "Easily rent the villa you want from Turkey's holiday gate to happiness!",
        footerPaymentLinkButtonText: "Our Website is Protected with a 256 Bit SSL <br /> Certificate for Credit Card <br class='lg:hidden' /> Purchases",
        pay: "PAY NOW",
        copyRight: "2023 @ All Rights Reserved. Content Cannot Be Used Without Permission.",
        wpSupport: "WhatsApp Support",
        wpMessage: "I want to get information about {Villa}.",
        calendarUnavailable: "Unavailable",
        calendarOption: "Option",
        calendarLastMinute: "Last Minute Deal",
        lastMinuteBadge: "LAST MINUTE",
        detailLastMinuteTitle: "Last Minute Deals",
        detailLastMinuteText: "Special price for the remaining days on these dates. Valid until booked.",
        selectTheseDates: "Select these dates",
        dateSelected: "Selected",
        datepickerCheckIn: "Check-in",
        datepickerCheckOut: "Check-out Date",
        warning: "Warning!",
        reservationUnavailableMessage: "The villa you are viewing is not available for reservations. If you wish, you can check out our other villas.",
        childAge: "6-12 Age",
        infant: "Infant",
        infantAge: "0-5 Age",
        back: "Back",
        reservationSubmitButtonText: "SEND A FREE BOOKING REQUEST",
        nameSurname: "Name & Surname",
        email: "Email",
        phone: "Phone",
        sendBtnText: "Send",
        reservationSummary: "Reservation Summary",
        accommodationAmount: "Accommodation Amount ({night} nights) ",
        remainingAmount: "Remaining (to be paid upon arrival)",
        takeTotalAmount: "Take Total Amount",
        cleaningFee: "Cleaning Fee",
        totalPrice: "Total Price",
        depositPrice: "Deposit Price",
        watchVideo: "Watch Video",
        showPhotos: "Show Photos",
        favourite: "Like",
        share: "Share",
        shareUpper: "SHARE",
        morePhotos: "More Photos",
        availabilityCalendar: "Availability Calendar",
        sidebarReservationTitle: "Reservation",
        sidebarReservationSubtitle: "<span class='text-orange'>{count} people</span> watching now",
        addFavourite: "Like",
        removeFavourite: "Unlike",
        shareViaWhatsapp: "Share via Whatsapp",
        shareViaFacebook: "Share via Facebook",
        shareViaTwitter: "Share via Twitter",
        shareViaMail: "Share via Mail",
        copyLink: "Copy Link",
        propertiesTitle: "Highlights",
        pricesTitle: "Prices",
        inludedPrice: "What's Included in the Price",
        notIncludedPrice: "What's Not Included in the Price",
        information: "Information",
        cancellationTerms: "Cancellation Terms",
        damageDeposit: "Damage Deposit",
        checkinTime: "Check-in Time (Earliest)",
        checkoutTime: "Check-out Time (Latest)",
        discover: "Discover",
        poolDimensions: "Pool Dimensions",
        poolType: "Pool Type",
        childPool: "Child Pool",
        indoorPool: "Indoor Pool",
        distancesTitle: "Transportation Information",
        showOnMap: "Show on Map",
        locationInformation: "Location information",
        goToLocation: "Go to location",
        detailSimilarVillasTitle: "Browse Similar Villas",
        favouritesRightTitle: "Favourites",
        favouritesRightNotFound: "No villas added to favorites were found.",
        FavouriteItemDetailBtnText: "View",
        FavouriteItemRemoveBtnText: "Remove",
        MenubarHomeText: "Home",
        MenubarSearchText: "Search",
        MenubarButtonFilterText: "Filter",
        MenubarButtonReservationText: "Booking",
        AllVillas: "All Villas",
        notDates: "Please specify your Entry/Exit dates.",
        reservationTitle: "You are making a reservation for <strong>{baslik}</strong>",
        reservationSection1Title: "Enter Your Personal Information",
        reservationFormNamePlaceholder: "Name Surname",
        reservationFormEmailPlaceholder: "Email",
        reservationFormPhonePlaceholder: "Phone",
        reservationFormPhonePlaceholder2: "Phone",
        reservationSection2Title: "Choose Your Payment Method After Approval",
        reservationPaymentAll: "All",
        paymentMethod1Title: "Pay by Bank Transfer",
        paymentMethod1Description: "I want to make the payment amount by Money Order or EFT.",
        paymentMethod2Title: "Pay by Credit Card",
        paymentMethod2Description: "You can make your payment by credit card in one payment or in installments up to 12 months.",
        reservationSection3Title: "Things to consider when entering the villa",
        reservationDamageDeposit: "Damage Deposit",
        reservationDamageDepositDescription: "If there is no damage to the villa, it will be refunded upon departure.",
        reservationCheckinCheckoutTime: "Check-in and Check-out Times",
        reservationCheckinTime: "Check-in Time ",
        reservationCheckoutTime: "Check-out Time ",
        contractText: "I have read and accept the {contractName}",
        contract1: "Rental Agreement",
        contract2: "KVKK Clarification Text",
        reservationSendValidationError: "Please fill in all the required fields.",
        reservationSendBtnText: "SEND RESERVATION REQUEST",
        reservationSuccessPageTitle: "Request Successful",
        reservationSuccessPageDescription: "Reservation Number: <strong class='text-black font-extrabold'>{id}</strong>",
        dear: "Dear",
        reservationSuccessPageSuccessMessage: "Your request has been received successfully.",
        reservationSucessPageMailSendedMessage: "An informative e-mail was sent to  <strong class='text-black font-bold'>{mail}</strong>",
        error: "Error!",
        SearchResultTitle: "Start Searching for Your Villa",
        SearchResultFilterSummeryText: "{totalRecord} Villas Listed",
        SearchResultFilterOrderPlaceHolder: "Sort",
        orderOptions: [
            {
                value: "0",
                label: "Smart Sorting"
            },
            // {
            //   value: "1",
            //   label: "By Date (Oldest First)",
            // },
            // {
            //   value: "2",
            //   label: "By Date (Newest First)",
            // },
            {
                value: "3",
                label: "By Price (Lowest First)"
            },
            {
                value: "4",
                label: "By Price (Highest First)"
            },
            {
                value: "5",
                label: "By Person (Lowest First)"
            },
            {
                value: "6",
                label: "By Person (Highest First)"
            }, 
        ],
        bankTransferFormTitle: "Transfer Notification Form",
        name: "Name",
        surname: "Surname",
        bankTransferFormAmount: "Amount Sent",
        bankTransferFormDate: "Sent Date",
        bankTransferFormReceivingBank: "Receiving Bank",
        bankTransferFormMessage: "Message",
        dateDay: "DD",
        dateMonth: "MM",
        dateYear: "YYYY",
        loginSuccess: "Login Success",
        loadingText: "Loading",
        login: "Login",
        bankTransferNotAuth: "You need to log in to send the Bank Transfer Notification Form.",
        ProductCategoryItemSubText: "{count} villas",
        loginLeftSubtitle: "Welcome back,",
        loginLeftTitle: "Reservation Tracking",
        loginLeftCopyRight: "2021 \xa9 All Rights Reserved. Unauthorized Content May Not Be Used.",
        welcome: "Welcome",
        loginRightDescription: "You can track or check your reservations from this section with your email address and reservation confirmation number. If you encounter any problems with your reservation, please contact our customer service immediately {contact}",
        loginRightDescriptionContactLink: "contact us.",
        loginFormEmail: "Your Email Address",
        loginReservationNumber: "Reservation Confirmation Code",
        loginRightDescriptionBottom: "To access this section, you must have previously made a reservation and received the email and confirmation code confirming your reservation. Customers who have only submitted a request cannot access this section.",
        logout: "Log Out",
        reservationsTab1: "Your Active Reservations",
        reservationsTab2: "Your Past Reservations",
        reservationsTab1Error: "No Active Reservations Found",
        reservationsTab2Error: "No Past Reservations Found",
        ReservationStatus0: "Pending Approval",
        ReservationStatus1: "Awaiting Payment",
        ReservationStatus1ActionBtn: "Submit Payment Notification",
        ReservationStatus1ActionCompleted: "Payment Notification Submitted",
        ReservationStatus1ActionBtn2: "Pay By Credit Card",
        ReservationStatus3: "Approved",
        ReservationStatus3Text: "Paid",
        ReservationStatus3ActionBtn: "Submit Payment Notification",
        ReservationStatus3ActionBtn2: "Please Enter Guest Information",
        ReservationStatus3ActionBtn2Completed: "Guest Information Entered",
        ReservationStatus4: "Cancelled",
        reservationNo: "Res. No",
        reservationDate: "Transaction Date / Time",
        reservationCustomerName: "Customer Name Surname",
        reservationDate1: "Check-In Date",
        reservationDate2: "Check-Out Date",
        reservationtionPrice: "Payment Amount",
        reservationGuestInformationTitle: "Please enter {name} information for Reservation number {reservationId}",
        reservationGuestInformationTitleName1: "Guest",
        reservationGuestInformationTitleName2: "Invoice details",
        reservationGuestInformationSubTitle: "You can accommodate up to {count} people.",
        GuestInformationTitle: "Guest Information {no}",
        GuestInformationName: "Full Name",
        GuestInformationGender: "Gender",
        GuestInformationGenderMale: "Male",
        GuestInformationGenderFemale: "Female",
        GuestInformationBirthDate: "Date of Birth",
        GuestInformationBirthPlace: "Place of Birth",
        GuestInformationPassaport: "Passport Number",
        GuestInformationTc: "TC Number",
        GuestInformationNotTurkeyPeople: "I'm not a Turkish citizen",
        goBack: "Go Back",
        save: "Save",
        GuestInformationInvoiceType: "Invoice Type",
        GuestInformationInvoiceTypeOption1: "Individual",
        GuestInformationInvoiceTypeOption2: "Corporate",
        GuestInformationInvoiceTypeOption1Name: "Full Name",
        GuestInformationInvoiceTypeOption2Name: "Company Name",
        GuestInformationInvoiceTaxOffice: "Tax Office",
        GuestInformationInvoiceTaxNumber: "Tax Number",
        address: "Address",
        GuestInformationSuccessfullyTitle: " Guest Information successfully received.",
        GuestInformationSuccessfullyDescription: "A summary of guest information has been sent to you by email. If you believe there is an error, please contact our Customer Service.",
        PayByCreditCardTitle: "Pay {price}",
        PayByCreditCardCaption: "Pay with Bank or Credit Card",
        PayByCreditCardFormName: "Full Name",
        PayByCreditCardFormCardNumber: "12-digit number on the card",
        PayByCreditCardFormSubmit: "Pay",
        PayByCreditCardRightTitle: "{night} Night Accommodation",
        PaymentAuthRequired: "You need to sign in to make a payment.",
        installementFull: "Single Payment",
        installement: "Installment",
        paymentSuccess: "\xd6deme Ba\u015Far\u0131l\u0131",
        paymentSuccessDescription: "Bu pencereyi kapatabilirsiniz.",
        paymentTryAgain: "L\xfctfen Tekrar Deneyiniz",
        getOfferStep1Title1: "Welcome to the",
        getOfferStep1Title2: "Villa finder wizard.",
        getOfferStep1Caption1: "Are you having difficulty finding",
        getOfferStep1Caption2: "the villa you are looking for?",
        getOfferStep1SubTitle: "Easily find the villa you're looking for in just 5 steps.",
        getOfferNextBtn: "Next",
        getOfferPrevBtn: "Prev",
        getOfferSendBtn: "Send Form",
        getOfferStep2Title: "WHAT KIND OF VILLA HOLIDAY ARE YOU LOOKING FOR",
        getOfferStep2Option1: "ECONOMICAL",
        getOfferStep2Option2: "MID-RANGE",
        getOfferStep2Option3: "LUXURY",
        getOfferStep3Title: "WHAT ARE YOU PLANNING YOUR HOLIDAY FOR?",
        getOfferStep3Option1: "Honeymoon or Special Occasion",
        getOfferStep3Option2: "With Family or Friends",
        getOfferStep4Title: "FEATURES YOU WANT IN YOUR VILLA",
        getOfferStep5Title: "YOUR INFORMATION",
        getOfferFormFullName: "Full Name",
        getOfferFormEmail: "Your Email Address",
        getOfferFormPhone: "Your Phone Number",
        getOfferFormPerson: "Number of People",
        getOfferFormAdult: "Adult",
        getOfferFormChild: "Child",
        getOfferFormInfant: "Infant",
        getOfferFormError: "An error occurred",
        getOfferModalTitle: "THANK YOU",
        getOfferModalCaption: "The villa finder wizard has started working to find the most suitable options for you.",
        getOfferModalDescription: "The selected villas will be sent to you via SMS and email as soon as possible.",
        blogSidebarSearchTitle: "Search",
        blogSidebarSearchPlaceHolder: "Search Blog",
        blogSidebarList1Title: "Latest Posts",
        blogSidebarList2Title: "Popular Posts",
        blogItemReadBtn: "Read More",
        bankItemBankName: "Bank Name",
        bankItemBankBranch: "Branch Name-Code",
        bankItemBankAccountName: "Account Name",
        bankItemBankIban: "IBAN Number",
        checkinInformationTitle: "Reservation Details",
        viewInvoice: "View Invoice Details",
        viewContract: "View Contract Details",
        customerInformations: "Customer Information",
        villaManager: "Villa Manager/Attendant",
        callNow: "Call Now",
        sendMessageViaWp: "Message via WhatsApp",
        earliest: "Earliest",
        latest: "Latest",
        paymentInformations: "Payment Information",
        paymentOwnerInformation: "Payment Information Detail",
        remaining: "Remaining",
        accommodationPrice: "Total Accommodation Price",
        paymentCheckin: "Payment to be Made at Check-in during entrance",
        creditcardNotAccepted: "(Credit card <span class='underline'>not accepted</span>)",
        entranceInformationDamageDeposit: "The amount to be paid upon entering the villa. In addition, a damage deposit of {damage} will be taken.",
        entranceInformationLocationErrorOwner: "Please contact your guest and provide the location information!",
        entranceInformationLocationErrorCustomer: "Please contact the Villa Manager/Attendant and request location information!",
        UnconditionalmoneyTitle: "Within 24 Hours",
        UnconditionalmoneySubTitle: "Unconditional Money Back",
        UnconditionalmoneyDescription: "*If CANCELLATION occurs within 24 hours following the confirmation of the reservation, the visitor receives a refund of the deposit paid unconditionally.",
        UnconditionalmoneyDescription2: "Not valid for reservations with a check-in date within the earliest 21 days.",
        discount: "Discount",
        discountedAccommodationAmount: "Discounted Accommodation Amount",
        appliedDiscount: "{code} code applied",
        ihaveapromotioncode: "I Have a Promotion Code",
        promotionCode: "Promotion Code",
        apply: "Apply",
        callCenterName: "Call Center",
        allVillasCta: "All rental villas",
        allVillasCtaSub: "Browse every villa without picking dates",
        allVillasCtaStrip: "Browse all rental villas without picking dates",
        allVillasCtaRest: "and every other region",
        disableCalendarRules: "Disable Calendar Rules",
        roomCount: "Room Count",
        paybackDamageInfo: "It will be collected upon arrival and returned to you upon departure if there is no damage.",
        paymentByCompany: "The amount to be sent by the agency",
        paymentByCompanyInfo: "The amount to be sent by the agency will be sent to your account within 1-5 working days after the check-in date.",
        accountDelete: "Account Delete",
        rezervationCode: "Reservation Code",
        memberLogin: "Member Login",
        noAccount: "Don't have an account?",
        register: "Sign Up",
        forgotPassword: "Forgot Password",
        loginError: "An error occurred while logging in.",
        newPassword: "New Password",
        confirmPassword: "Confirm Password",
        updatePassword: "Update Password",
        otpCode: "Verification Code",
        verifyCode: "Verify Code",
        resendCode: "Resend Code",
        otpRequired: "Verification code is required",
        otpLength: "Code must be 6 digits",
        otpError: "Code could not be verified.",
        otpResendSuccess: "Verification code has been resent.",
        otpResendError: "Code could not be resent.",
        passwordRequired: "Password is required",
        passwordMin: "Password must be at least 6 characters",
        passwordsNotMatch: "Passwords do not match",
        passwordUpdateSuccess: "Your password has been successfully updated!",
        passwordUpdateError: "Password could not be updated.",
        completeRegistration: "Complete Registration",
        nameRequired: "Name is required",
        surnameRequired: "Surname is required",
        emailRequired: "Email is required",
        emailInvalid: "Please enter a valid email",
        registrationSuccess: "Your account has been created!",
        registrationError: "Registration could not be completed.",
        password: "Password",
        sendResetCode: "Send Reset Code",
        backToLogin: "Back to Login",
        createNewPassword: "Create New Password",
        continue: "Continue",
        phoneRequired: "Phone number is required",
        phoneInvalid: "Please enter a valid number",
        operationFailed: "Operation failed.",
        newPasswordRequired: "New password is required",
        confirmPasswordRequired: "Password confirmation is required",
        // --- New texts (site 2 translation) ---
        faqTitle: "Frequently Asked Questions",
        instagramSubtitle: "Holiday Villas for Rent",
        instagramText: "Follow us to discover the most special villas in and around Fethiye and see our guests' experiences.",
        instagramFollow: "Follow on Instagram",
        discountedBadge: "Discounted",
        instantBooking: "Instant Booking",
        googleReviewsTitle: "Google Guest Reviews",
        googleReviewsCount: "1,179 Real Reviews",
        viewAllReviews: "View all reviews",
        excellent: "Excellent",
        weekly: "Weekly",
        workingHours: "Working Hours",
        noResultFound: "No Results Found",
        mobileMenuLabel: "Mobile Menu",
        copied: "Copied!",
        reviewCtaTitle: "Have You Stayed With Us?",
        reviewCtaThisVilla: "this villa",
        reviewCtaText: "\u2014 how was your stay? Share your experience with us and other guests to help them choose.",
        ministryOfTourism: "Republic of T\xfcrkiye Ministry of Culture and Tourism",
        applicationNo: " Application No: ",
        applicationInProgress: " Application in Progress",
        cancel: "Cancel",
        clearSelection: "Clear selection",
        sidebarPayNowText: "Pay now without waiting for pre-approval and complete your reservation.",
        bedroom1: "Bedroom 1",
        bedroom2: "Bedroom 2",
        garden: "Garden",
        doubleBed: "Double Bed",
        bathroomDoubleBed: "Bathroom Double Bed",
        poolLength: "Length",
        poolWidth: "Width",
        poolDepth: "Depth",
        directionsAria: "Get directions to our office",
        timeAlmostUp: "Time Is Running Out!",
        paymentTime: "Payment Time",
        timeLeftToComplete: "Time left to complete your reservation",
        dayShort: "Days",
        feedbackThanks: "Thank you for your feedback...",
        feedbackChooseRating: "Please select a valid rating.",
        feedbackAsk: "Our website has been renewed. Would you like to rate our new website?",
        no: "No",
        yourRating: "Your Rating",
        pleaseSelect: "Please select",
        certificateLabel: "Certificate",
        certificateNo: " No: ",
        rentableNow: "Available to Book Instantly",
        errorTitle: "Error",
        warningTitle: "Warning",
        attention: "Attention",
        hoursLabel: "Hours",
        minutesLabel: "Minutes",
        secondsLabel: "Seconds",
        followUs: "Follow Us",
        ourOffice: "Our Office",
        getDirections: "Get Directions",
        footerAddress: "Akarca District, Adnan Menderes Boulevard No:205/C 1-2-3, Fethiye / Mu\u011Fla, T\xfcrkiye",
        learnMore: "Learn more",
        favouritesAria: "Favourites",
        favouriteAria: "Favourite",
        writeReviewShort: "Write a Review",
        googleWriteReview: "Review Us on Google",
        nightLabel: "Nights",
        moreInfo: "More Info",
        free: "Free",
        dateLabel: "Date",
        amountLabel: "Amount",
        statusLabel: "Status",
        feeLabel: "Fee",
        statusAvailable: "Available",
        statusUnavailable: "Unavailable",
        serviceFreePre: "For the available dates you can use this service",
        serviceFreeStrong: "free of charge.",
        serviceFreePost: "",
        servicePaidPre: "A total fee of",
        servicePaidPost: "will be charged for the available dates.",
        mobileAppDiscount: "Mobile app exclusive discount",
        promoCodeDiscount: "Promotion Code Discount",
        heatedPool: "Heated Pool",
        optionalServices: "Optional Services",
        heatingPoolTitle: "Heated Pool Fees and Availability",
        notUsable: "Not available",
        usable: "Available",
        closeBtn: "Close",
        wantHeatedPool: "I would like to use the heated pool",
        heatedPoolDatesPre: "To see the dates when the heating service is available",
        heatedPoolDatesClick: "click here",
        availableDatesText: "Available dates for booking this property",
        selectBtn: "Select",
        loadingDots: "Loading...",
        continueAnyway: "Continue Anyway",
        availableDatesWarning: "This usually has a negative outcome. However, if you wish, we can review your request again or you can choose from alternative dates.",
        payNow: "Pay now",
        contactAddress: "Address",
        contactPhoneEmail: "Phone & Email",
        contactShare: "Share",
        contactForm: "Contact Form",
        contactFullName: "Your Full Name",
        contactPhone: "Your Phone Number",
        contactEmail: "Your Email Address",
        contactSubject: "Subject",
        contactMessage: "Your Message",
        contactSecurityCode: "Security Code",
        contactSecurityCodeEnter: "Enter the Security Code",
        contactSendForm: "SEND FORM",
        contactMap: "Map",
        creditCardInstantNote: "When you choose to pay by credit card, your reservation will be completed instantly and confirmed without any approval process.",
        cardNumberLength: "Card number must be 16 digits.",
        paymentStatusChecking: "Checking payment status...",
        paymentSuccessToast: "Payment Successful",
        closeWindowAfterPayment: "You can close this window after completing your payment.",
        clickToPay: "Click to Make a Payment",
        installments369: "3-6-9 instalments available on all bank cards",
        bankRatesApply: "The rates set by the banks apply",
        successTitle: "Successful",
        paymentReceived: "Your payment has been received successfully.",
        paymentInfoSentTo: "\u2013 payment details have been sent to this address.",
        contactAndPaymentInfo: "Contact and Payment Information",
        fullNameLabel: "Full Name",
        creditCardInfo: "Credit Card Information",
        cardNumberLabel: "Card Number",
        loadingShort: "Loading",
        payBtn: "Pay",
        sslNotice: "Payments you make via {domain} are encrypted with a 256-Bit SSL Certificate and sent to the bank. Information is exchanged securely between your bank and {site}, and your card details are not stored in any database.",
        heatedPoolFee: "Heated Pool Fee",
        sliderCaptionDefault: "Start your holiday in a villa with a private pool",
        ownerWelcomeBack: "Welcome back,",
        ownerPanelTitle: "Villa Owner Management Panel",
        ownerCopyright: "2021 @ All Rights Reserved. Content may not be used without permission.",
        ownerWelcome: "Welcome.",
        ownerIntroPre: "You can follow or manage your villas from this section with the e-mail address and password given to you. If you encounter any problem with your villas, please contact our customer service urgently:",
        ownerIntroLink: "contact us.",
        ownerLoginError: "Incorrect username or password.",
        usernameLabel: "Username",
        passwordLabel2: "Password",
        loginBtn2: "Log In",
        advertiseQPre: "Are You a ",
        advertiseQStrong: "Villa ",
        advertiseQPost: "Owner?",
        advertiseFormReceived: "Your form has been received. Our relevant department will get back to you as soon as possible. Thank you for your interest.",
        poolPrivate: "Private Pool",
        poolShared: "Shared Pool",
        poolNone: "No Pool",
        seaViewLabel: "Sea View",
        yesLabel: "Yes",
        noLabel: "No",
        yourMessagePlaceholder: "Your message",
        advInfo1Title: "ACCURATE PRICING AND EARNINGS PLANNING",
        advInfo1Text: "We compare your villa with similar properties, taking into account its features, capacity and location, and prepare the most accurate pricing study, including a detailed seasonal earnings scenario.",
        advInfo2Title: "PROFILE AND LISTING MANAGEMENT",
        advInfo2Text: "Together with our expert team, we present your villa to the right audience through targeted advertising. With effective social media management and experience, we work meticulously to help you reach the highest occupancy.",
        advInfo3Title: "24/7 GUEST SUPPORT LINE",
        advInfo3Text: "With our 7 days / 24 hours call center service, we respond instantly to our guests' requests and questions. We provide continuous support, regardless of day or time.",
        advInfo4Title: "PROFESSIONAL PHOTO & VIDEO SHOOTS",
        advInfo4Text: "Photography is one of the most important factors in promoting a villa, and our professional team takes care of it. Our shoots are carried out meticulously using methods suitable for effective use in advertising and on social media accounts.",
        advInfo5Title: "EVALUATION AND INFORMATION",
        advInfo5Text: "To help your villa reach maximum occupancy, you can get evaluations and detailed information from our experienced team from start to finish on topics such as interior and exterior design and the contribution of equipment features, so you can receive more booking requests.",
        ptdTitle1: "Pay on",
        ptdTitle2: "Arrival",
        ptdTitle3: "System",
        ptdP1: "requires an ADVANCE PAYMENT of between 15% and 40%, depending on the villa, at the reservation stage.",
        ptdP2: "You can pay the remaining amount to the Villa Owner on the day you check in to the villa.",
        ptdP3: "How the villa owner will collect your REMAINING payment is stated in the EMAIL you receive at the reservation stage.",
        refundTitle1: "In Case of Problems Caused by the Villa Owner",
        refundTitle2: "100% Money Back",
        refundP1Pre: "This applies if you cannot reach the villa owner within 6 hours of your check-in time at the villa you reserved for your holiday, or if the villa differs from the one shown in the photos (excluding furniture and decoration changes). The full amount you have paid will be",
        refundP1Strong: "refunded",
        refundP1Post: "to you.",
        refundP2: "works to make up for this inconvenience: our Sales Consultants will help you find an available villa in the same region at a discounted rate, with no commission earned, so that you can continue your holiday.",
        refundP3: "For any problems you may experience during your holiday other than these cases, {site} will help resolve the issue as quickly as possible and, if it cannot be resolved, help you move to a different villa if one is available.",
        securaTitle1: "Secure",
        securaTitle2: "Payment",
        securaTitle3: "System",
        securaP1Pre: "is a",
        securaP1Company: "Co\u015Fkunlar Ticaret Emlak Turizm \u0130n\u015Faat Limited \u015Eirketi",
        securaP1Post: "company.",
        securaP2: "Our website uses the SSL protocol encryption system (impossible to decrypt), a 256-bit secure site and the 3D Secure payment system.",
        securaP3: "You can pay by credit card through the Virtual POS system or by bank transfer / EFT to our official company accounts.",
        securaPolicyTitle: "This Privacy Policy:",
        securaPolicyText: "covers all users who visit and use {domain} and is accepted in advance. The data that visitors using {domain} provide to us directly and/or indirectly is described below. This data is used only in the cases permitted under the Rental and Use Agreement and the terms of the Privacy Policy, and is not used outside those cases.",
        installPre: "Make your reservation now,",
        installMid: "and pay comfortably by credit card in instalments. {site} offers up to 12 instalments on all credit cards.",
        installNote: "Interest rates for instalment options are determined by your bank. Before making your reservation, you can check the rates applied by your bank and take advantage of the instalment option.",
        installUpTo: "Up to 12 instalments",
        installTursab: "{site} Tourism Travel Agency is affiliated with the Republic of T\xfcrkiye Ministry of Tourism with T\xdcRSAB Certificate A-14264.",
        paidAccommodationAmount: "Accommodation Amount Paid",
        remainingAccommodationAmount: "Remaining Accommodation Amount"
    }
};
var language = languages["tr"];


/***/ }),

/***/ 71210:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.getDomainLocale = getDomainLocale;
var basePath =  false || "";
function getDomainLocale(path, locale, locales, domainLocales) {
    if (true) {
        var normalizeLocalePath = (__webpack_require__(78875).normalizeLocalePath);
        var detectDomainLocale = (__webpack_require__(38748).detectDomainLocale);
        var target = locale || normalizeLocalePath(path, locales).detectedLocale;
        var domain = detectDomainLocale(domainLocales, undefined, target);
        if (domain) {
            var proto = "http".concat(domain.http ? "" : "s", "://");
            var finalLocale = target === domain.defaultLocale ? "" : "/".concat(target);
            return "".concat(proto).concat(domain.domain).concat(basePath).concat(finalLocale).concat(path);
        }
        return false;
    } else {}
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=get-domain-locale.js.map


/***/ }),

/***/ 28045:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _define_property = (__webpack_require__(79361)["default"]);
var _sliced_to_array = (__webpack_require__(94941)/* ["default"] */ .Z);
var _to_consumable_array = (__webpack_require__(53929)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _react = _interopRequireWildcard(__webpack_require__(67294));
var _head = _interopRequireDefault(__webpack_require__(5443));
var _imageConfig = __webpack_require__(99309);
var _useIntersection = __webpack_require__(57190);
var _imageConfigContext = __webpack_require__(59977);
var _utils = __webpack_require__(63794);
var _normalizeTrailingSlash = __webpack_require__(82392);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, lazyBoundary = _param.lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, style = _param.style, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _objectWithoutPropertiesLoose(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _to_consumable_array(c.deviceSizes).concat(_to_consumable_array(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _extends({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    var loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _objectWithoutPropertiesLoose(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    if (experimentalUnoptimized) {
        unoptimized = true;
    }
    var ref = _sliced_to_array((0, _react).useState(false), 2), blurComplete = ref[0], setBlurComplete = ref[1];
    var ref1 = _sliced_to_array((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary || "200px",
        disabled: !isLazy
    }), 3), setIntersection = ref1[0], isIntersected = ref1[1], resetIntersected = ref1[2];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign({}, style, layoutStyle);
    var blurStyle = placeholder === "blur" && !blurComplete ? {
        backgroundSize: objectFit || "cover",
        backgroundPosition: objectPosition || "0% 0%",
        filter: "blur(20px)",
        backgroundImage: 'url("'.concat(blurDataURL, '")')
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (true) {
        imageSrcSetPropName = "imageSrcSet";
        imageSizesPropName = "imageSizes";
    }
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _define_property(_obj, imageSrcSetPropName, imgAttributes.srcSet), _define_property(_obj, imageSizesPropName, imgAttributes.sizes), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    var previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    var imgElementArgs = _extends({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        layout: layout,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setIntersection: setIntersection,
        isVisible: isVisible,
        noscriptSizes: sizes
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache() {
    if (typeof WeakMap !== "function") return null;
    var cache = new WeakMap();
    _getRequireWildcardCache = function _getRequireWildcardCache() {
        return cache;
    };
    return cache;
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache();
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ref = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","experimentalLayoutRaw":false} || {}, _experimentalRemotePatterns = ref.experimentalRemotePatterns, experimentalRemotePatterns = _experimentalRemotePatterns === void 0 ? [] : _experimentalRemotePatterns, experimentalUnoptimized = ref.experimentalUnoptimized;
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","experimentalLayoutRaw":false};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
var loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === "fill" || layout === "responsive")) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _to_consumable_array(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _to_consumable_array(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref = getWidths(config, width, layout, sizes), widths = ref.widths, kind = ref.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref;
    var loaderKey = ((ref = loaderProps.config) == null ? void 0 : ref.loader) || "default";
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef == null ? void 0 : onLoadingCompleteRef.current) {
            var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight
            });
        }
        if (false) { var parent, ref; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, layout = _param.layout, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setIntersection = _param.setIntersection, onLoad = _param.onLoad, onError = _param.onError, isVisible = _param.isVisible, noscriptSizes = _param.noscriptSizes, rest = _objectWithoutPropertiesLoose(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible",
        "noscriptSizes"
    ]);
    loading = isLazy ? "lazy" : loading;
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _extends({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            setIntersection(img);
            if (img == null ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: srcString,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: noscriptSizes,
        loader: loader
    }), {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading
    }))));
};
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    params.set("auto", params.get("auto") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    var paramsString = params.join(",") + "/";
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var hasMatch, parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 48418:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _sliced_to_array = (__webpack_require__(94941)/* ["default"] */ .Z);
var _type_of = (__webpack_require__(45753)["default"]);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
var _router = __webpack_require__(76273);
var _addLocale = __webpack_require__(22725);
var _routerContext = __webpack_require__(63462);
var _appRouterContext = __webpack_require__(21018);
var _useIntersection = __webpack_require__(57190);
var _getDomainLocale = __webpack_require__(71210);
var _addBasePath = __webpack_require__(98684);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// @ts-ignore useTransition exist
var hasUseTransition = typeof _react.default.useTransition !== "undefined";
var prefetched = {};
function prefetch(router, href, as, options) {
    if ( false || !router) return;
    if (!(0, _router).isLocalURL(href)) return;
    // Prefetch the JSON page if asked (only in the client)
    // We need to handle a prefetch error here since we may be
    // loading with priority which can reject but we don't
    // want to force navigation since this is only a prefetch
    router.prefetch(href, as, options).catch(function(err) {
        if (false) {}
    });
    var curLocale = options && typeof options.locale !== "undefined" ? options.locale : router && router.locale;
    // Join on an invalid URI character
    prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")] = true;
}
function isModifiedEvent(event) {
    var target = event.currentTarget.target;
    return target && target !== "_self" || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.nativeEvent && event.nativeEvent.which === 2;
}
function linkClicked(e, router, href, as, replace, shallow, scroll, locale, startTransition) {
    var nodeName = e.currentTarget.nodeName;
    // anchors inside an svg have a lowercase nodeName
    var isAnchorNodeName = nodeName.toUpperCase() === "A";
    if (isAnchorNodeName && (isModifiedEvent(e) || !(0, _router).isLocalURL(href))) {
        // ignore click for browser’s default behavior
        return;
    }
    e.preventDefault();
    var navigate = function() {
        // replace state instead of push if prop is present
        router[replace ? "replace" : "push"](href, as, {
            shallow: shallow,
            locale: locale,
            scroll: scroll
        });
    };
    if (startTransition) {
        startTransition(navigate);
    } else {
        navigate();
    }
}
var Link = /*#__PURE__*/ _react.default.forwardRef(function LinkComponent(props, forwardedRef) {
    if (false) { var hasWarned, optionalProps, optionalPropsGuard, requiredProps, requiredPropsGuard, createPropError; }
    var children;
    var hrefProp = props.href, asProp = props.as, childrenProp = props.children, prefetchProp = props.prefetch, passHref = props.passHref, replace = props.replace, shallow = props.shallow, scroll = props.scroll, locale = props.locale, onClick = props.onClick, onMouseEnter = props.onMouseEnter, _legacyBehavior = props.legacyBehavior, legacyBehavior = _legacyBehavior === void 0 ? Boolean(false) !== true : _legacyBehavior, restProps = _objectWithoutPropertiesLoose(props, [
        "href",
        "as",
        "children",
        "prefetch",
        "passHref",
        "replace",
        "shallow",
        "scroll",
        "locale",
        "onClick",
        "onMouseEnter",
        "legacyBehavior"
    ]);
    children = childrenProp;
    if (legacyBehavior && (typeof children === "string" || typeof children === "number")) {
        children = /*#__PURE__*/ _react.default.createElement("a", null, children);
    }
    var p = prefetchProp !== false;
    var ref = _sliced_to_array(hasUseTransition ? // @ts-ignore useTransition exists
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.default.useTransition() : [], 2), /* isPending */ startTransition = ref[1];
    var router = _react.default.useContext(_routerContext.RouterContext);
    var appRouter = _react.default.useContext(_appRouterContext.AppRouterContext);
    if (appRouter) {
        router = appRouter;
    }
    var ref1 = _react.default.useMemo(function() {
        var ref = _sliced_to_array((0, _router).resolveHref(router, hrefProp, true), 2), resolvedHref = ref[0], resolvedAs = ref[1];
        return {
            href: resolvedHref,
            as: asProp ? (0, _router).resolveHref(router, asProp) : resolvedAs || resolvedHref
        };
    }, [
        router,
        hrefProp,
        asProp
    ]), href = ref1.href, as = ref1.as;
    var previousHref = _react.default.useRef(href);
    var previousAs = _react.default.useRef(as);
    // This will return the first child, if multiple are provided it will throw an error
    var child;
    if (legacyBehavior) {
        if (false) {} else {
            child = _react.default.Children.only(children);
        }
    }
    var childRef = legacyBehavior ? child && typeof child === "object" && child.ref : forwardedRef;
    var ref2 = _sliced_to_array((0, _useIntersection).useIntersection({
        rootMargin: "200px"
    }), 3), setIntersectionRef = ref2[0], isVisible = ref2[1], resetVisible = ref2[2];
    var setRef = _react.default.useCallback(function(el) {
        // Before the link getting observed, check if visible state need to be reset
        if (previousAs.current !== as || previousHref.current !== href) {
            resetVisible();
            previousAs.current = as;
            previousHref.current = href;
        }
        setIntersectionRef(el);
        if (childRef) {
            if (typeof childRef === "function") childRef(el);
            else if (typeof childRef === "object") {
                childRef.current = el;
            }
        }
    }, [
        as,
        childRef,
        href,
        resetVisible,
        setIntersectionRef
    ]);
    _react.default.useEffect(function() {
        var shouldPrefetch = isVisible && p && (0, _router).isLocalURL(href);
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        var isPrefetched = prefetched[href + "%" + as + (curLocale ? "%" + curLocale : "")];
        if (shouldPrefetch && !isPrefetched) {
            prefetch(router, href, as, {
                locale: curLocale
            });
        }
    }, [
        as,
        href,
        isVisible,
        locale,
        p,
        router
    ]);
    var childProps = {
        ref: setRef,
        onClick: function(e) {
            if (false) {}
            if (!legacyBehavior && typeof onClick === "function") {
                onClick(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onClick === "function") {
                child.props.onClick(e);
            }
            if (!e.defaultPrevented) {
                linkClicked(e, router, href, as, replace, shallow, scroll, locale, appRouter ? startTransition : undefined);
            }
        },
        onMouseEnter: function(e) {
            if (!legacyBehavior && typeof onMouseEnter === "function") {
                onMouseEnter(e);
            }
            if (legacyBehavior && child.props && typeof child.props.onMouseEnter === "function") {
                child.props.onMouseEnter(e);
            }
            if ((0, _router).isLocalURL(href)) {
                prefetch(router, href, as, {
                    priority: true
                });
            }
        }
    };
    // If child is an <a> tag and doesn't have a href attribute, or if the 'passHref' property is
    // defined, we specify the current 'href', so that repetition is not needed by the user
    if (!legacyBehavior || passHref || child.type === "a" && !("href" in child.props)) {
        var curLocale = typeof locale !== "undefined" ? locale : router && router.locale;
        // we only render domain locales if we are currently on a domain locale
        // so that locale links are still visitable in development/preview envs
        var localeDomain = router && router.isLocaleDomain && (0, _getDomainLocale).getDomainLocale(as, curLocale, router.locales, router.domainLocales);
        childProps.href = localeDomain || (0, _addBasePath).addBasePath((0, _addLocale).addLocale(as, curLocale, router && router.defaultLocale));
    }
    return legacyBehavior ? /*#__PURE__*/ _react.default.cloneElement(child, childProps) : /*#__PURE__*/ _react.default.createElement("a", Object.assign({}, restProps, childProps), children);
});
var _default = Link;
exports["default"] = _default;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=link.js.map


/***/ }),

/***/ 78875:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.normalizeLocalePath = void 0;
var normalizeLocalePath = function(pathname, locales) {
    if (true) {
        return (__webpack_require__(94317).normalizeLocalePath)(pathname, locales);
    }
    return {
        pathname: pathname,
        detectedLocale: undefined
    };
};
exports.normalizeLocalePath = normalizeLocalePath;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=normalize-locale-path.js.map


/***/ }),

/***/ 57190:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _sliced_to_array = (__webpack_require__(94941)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(9311);
var hasIntersectionObserver = typeof IntersectionObserver === "function";
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var unobserve = (0, _react).useRef();
    var ref = _sliced_to_array((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _sliced_to_array((0, _react).useState(null), 2), element = ref1[0], setElement = ref1[1];
    (0, _react).useEffect(function() {
        if (hasIntersectionObserver) {
            if (unobserve.current) {
                unobserve.current();
                unobserve.current = undefined;
            }
            if (isDisabled || visible) return;
            if (element && element.tagName) {
                unobserve.current = observe(element, function(isVisible) {
                    return isVisible && setVisible(isVisible);
                }, {
                    root: rootRef == null ? void 0 : rootRef.current,
                    rootMargin: rootMargin
                });
            }
            return function() {
                unobserve.current == null ? void 0 : unobserve.current();
                unobserve.current = undefined;
            };
        } else {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        element,
        isDisabled,
        rootMargin,
        rootRef,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    return [
        setElement,
        visible,
        resetVisible
    ];
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
        if (instance) {
            return instance;
        }
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    instance = {
        id: id,
        observer: observer,
        elements: elements
    };
    idList.push(id);
    observers.set(id, instance);
    return instance;
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 21018:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.AppRouterContext = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var AppRouterContext = _react.default.createContext(null);
exports.AppRouterContext = AppRouterContext;
if (false) {} //# sourceMappingURL=app-router-context.js.map


/***/ }),

/***/ 90638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var _instanceof = (__webpack_require__(96856)/* ["default"] */ .Z);
var _object_spread = (__webpack_require__(50337)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _react = _interopRequireDefault(__webpack_require__(67294));
var _loadable = _interopRequireDefault(__webpack_require__(14302));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _object_spread({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _object_spread({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _object_spread({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 16319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var _class_call_check = (__webpack_require__(79658)/* ["default"] */ .Z);
var _create_class = (__webpack_require__(7222)/* ["default"] */ .Z);
var _object_spread = (__webpack_require__(50337)/* ["default"] */ .Z);
var _object_spread_props = (__webpack_require__(49961)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
var _loadableContext = __webpack_require__(16319);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var useSyncExternalStore = ( true ? __webpack_require__(67294) : 0).useSyncExternalStore;
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var useLoadableModule = function useLoadableModule() {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        useLoadableModule();
        var state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _object_spread_props(_object_spread({}, props), {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _class_call_check(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _create_class(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            var _this1 = this;
                            this._delay = setTimeout(function() {
                                _this1._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        var _this2 = this;
                        this._timeout = setTimeout(function() {
                            _this2._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _object_spread(_object_spread_props(_object_spread({}, this._state), {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }), partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 57966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./styles/globals.css
var globals = __webpack_require__(40906);
// EXTERNAL MODULE: ./styles/ListVilla.css
var ListVilla = __webpack_require__(89966);
// EXTERNAL MODULE: ./context/context.js
var context = __webpack_require__(94268);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/skeleton.css
var skeleton = __webpack_require__(34714);
// EXTERNAL MODULE: ./static/Header.module.css
var Header_module = __webpack_require__(98015);
var Header_module_default = /*#__PURE__*/__webpack_require__.n(Header_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/index.mjs
var dist = __webpack_require__(84849);
// EXTERNAL MODULE: ./themes/themes.js
var themes = __webpack_require__(89507);
// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
;// CONCATENATED MODULE: ./components/Header/LanguageSwitch.js


var isDev = "production" === "development";
var targets = {
    tr: {
        // Türkçe sitedeyken İngilizce siteye git
        url: isDev ? "http://localhost:3001" : "https://www.villavillam.co.uk",
        flag: "/flags/gb.svg",
        title: "English",
        alt: "United Kingdom flag"
    },
    en: {
        // İngilizce sitedeyken Türkçe siteye git
        url: isDev ? "http://localhost:3000" : "https://www.villavillam.com.tr",
        flag: "/flags/tr.svg",
        title: "T\xfcrk\xe7e",
        alt: "Flag of T\xfcrkiye"
    }
};
var SHOW_LANGUAGE_SWITCH = false; // true yapinca bayrak gorunur
var LanguageSwitch = function() {
    if (!SHOW_LANGUAGE_SWITCH) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "ml-auto"
    });
    // Sadece villavillam.com.tr (1) ve villavillam.co.uk (2) arasinda gecis var.
    // Diger siteler (ör. balayivillasikirala = 3) icin bayrak gosterilmez;
    // ancak basliktaki sag hizalama (ml-auto) korunsun diye bos bir bosluk doner.
    var site = "1";
    if (site !== "1" && site !== "2") return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "ml-auto"
    });
    var target = targets["tr"] || targets.tr;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
        href: target.url,
        title: target.title,
        hrefLang:  false ? 0 : "en",
        className: "flex items-center justify-center shrink-0 ml-auto mr-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            src: target.flag,
            alt: target.alt,
            width: "32",
            height: "24",
            className: "block w-8 h-6 rounded-sm shadow-sm ring-1 ring-black/10"
        })
    });
};
/* harmony default export */ var Header_LanguageSwitch = (LanguageSwitch);

;// CONCATENATED MODULE: ./static/Header/HeaderLeft.js










var MobileTopBar = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 86646).then(__webpack_require__.bind(__webpack_require__, 86646));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86646)
            ];
        }
    },
    loading: function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
            count: 3,
            width: 40,
            height: 40,
            circle: true,
            containerClassName: "flex gap-x-0.5"
        });
    }
});
var Menu = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 10602).then(__webpack_require__.bind(__webpack_require__, 10602));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10602)
            ];
        }
    }
});
var HeaderLeft = function(param) {
    var headerContent = param.headerContent, isAppWebView = param.isAppWebView;
    var ref;
    var headerLeft = (0,TranslationContext/* useTranslation */.m)().headerLeft;
    if (false) {}
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex items-center w-full lg:w-7/12 2xl:w-3/5 lg:bg-header-bg-white ".concat(themes/* default.header.borderClass */.Z.header.borderClass),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    title: headerContent === null || headerContent === void 0 ? void 0 : (ref = headerContent.static) === null || ref === void 0 ? void 0 : ref.Home.title,
                    className: "mr-1 2xl:mr6",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(themes/* default.headerLogoClass */.Z.headerLogoClass, " relative"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: themes/* default.logo */.Z.logo,
                            alt: "Villa Villam" + " Logo",
                            layout: "fill",
                            objectFit: "contain",
                            priority: 1
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: "hidden ml-5 xl:flex gap-x-1",
                children: headerLeft.map(function(e, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: e.url,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            title: e.title,
                            children: e.text
                        })
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_LanguageSwitch, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileTopBar, {
                isAppWebView: isAppWebView
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu, {
                headerContent: headerContent
            })
        ]
    });
};
/* harmony default export */ var Header_HeaderLeft = (HeaderLeft);

// EXTERNAL MODULE: ./node_modules/is-mobile/index.js
var is_mobile = __webpack_require__(63805);
var is_mobile_default = /*#__PURE__*/__webpack_require__.n(is_mobile);
;// CONCATENATED MODULE: ./static/Header.js






var HeaderRight = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(63755), __webpack_require__.e(9012), __webpack_require__.e(38380)]).then(__webpack_require__.bind(__webpack_require__, 79197));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79197)
            ];
        }
    },
    ssr: false
});
var Header = function(param) {
    var headerContent = param.headerContent, isAppWebView = param.isAppWebView;
    var isPhone = is_mobile_default()();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "z-50 relative " + (Header_module_default()).Header,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container " + (Header_module_default()).Wrapper,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HeaderLeft, {
                        headerContent: headerContent,
                        isAppWebView: isAppWebView
                    }),
                    !isPhone ? /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderRight, {}) : null
                ]
            })
        })
    });
};
/* harmony default export */ var static_Header = (/*#__PURE__*/(0,react.memo)(Header));

// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/Structural.js



var Structural = function(param) {
    var data = param.data;
    return data && data.map(function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
            type: "application/ld+json",
            id: "Structural_".concat(item.id),
            strategy: "beforeInteractive",
            dangerouslySetInnerHTML: {
                __html: JSON.stringify(item.content)
            }
        }, item.id);
    });
};
/* harmony default export */ var components_Structural = (Structural);

// EXTERNAL MODULE: ./scripts/criteo.js
var criteo = __webpack_require__(77793);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./static/PageScripts.js





// import { GTM_ID, pageview } from "../scripts/gtm";
// import * as fbq from "../scripts/fpixel";
// import * as gtag from "../scripts/gtag";
var PageScripts = function(param) {
    var ssr = param.ssr, isAppWebView = param.isAppWebView;
    var router = (0,next_router.useRouter)();
    (0,react.useEffect)(function() {
        var ref, ref1, ref2, ref3;
        if ((ssr === null || ssr === void 0 ? void 0 : (ref = ssr.data) === null || ref === void 0 ? void 0 : ref.RoutingTypeId) == "Home") criteo/* homeview */.j4();
        if ((ssr === null || ssr === void 0 ? void 0 : (ref1 = ssr.data) === null || ref1 === void 0 ? void 0 : ref1.RoutingTypeId) == "ProductDetail") criteo/* detail */.lA(ssr === null || ssr === void 0 ? void 0 : (ref2 = ssr.data) === null || ref2 === void 0 ? void 0 : ref2.EntityId);
        // fbq.pageview();
        if (router === null || router === void 0 ? void 0 : (ref3 = router.query) === null || ref3 === void 0 ? void 0 : ref3.pCode) {
            var ref4;
            localStorage.setItem("PromotionCode", router === null || router === void 0 ? void 0 : (ref4 = router.query) === null || ref4 === void 0 ? void 0 : ref4.pCode);
        }
    }, [
        ssr
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isAppWebView && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    src: "//static.criteo.net/js/ld/ld.js"
                }),
                 true && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "cookieyes",
                    strategy: "afterInteractive",
                    src: "https://cdn-cookieyes.com/client_data/320fae27b7b436140be5324e/script.js"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                    id: "natsisa-tracker",
                    src: "https://channels.natsisa.com/api/tracker/script/E1E2631F-D591-41DF-9A50-6E8043141B6D",
                    strategy: "beforeInteractive"
                })
            ]
        })
    });
};
/* harmony default export */ var static_PageScripts = (PageScripts);

;// CONCATENATED MODULE: ./pages/_app.js











function MyApp(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TranslationContext/* TranslationProvider */.$, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(context/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Structural, {
                    data: (ref = pageProps.data) === null || ref === void 0 ? void 0 : ref.result.Structural
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(static_PageScripts, {
                    ssr: pageProps.data,
                    isAppWebView: pageProps.isAppWebView
                }),
                ((ref1 = pageProps.data) === null || ref1 === void 0 ? void 0 : ref1.RoutingAction) != "SinglePayment" && ((ref2 = pageProps.data) === null || ref2 === void 0 ? void 0 : ref2.disableHeader) != true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(static_Header, {
                    headerContent: (ref3 = pageProps.data) === null || ref3 === void 0 ? void 0 : ref3.headerContent,
                    isAppWebView: pageProps.isAppWebView
                }) : "",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
            ]
        })
    });
}
/* harmony default export */ var _app = (MyApp);


/***/ }),

/***/ 77793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j4": function() { return /* binding */ homeview; },
/* harmony export */   "lA": function() { return /* binding */ detail; },
/* harmony export */   "mG": function() { return /* binding */ payment; },
/* harmony export */   "rz": function() { return /* binding */ listing; },
/* harmony export */   "v9": function() { return /* binding */ sendReservation; }
/* harmony export */ });
var homeview = function() {
    window.criteo_q = window.criteo_q || [];
    var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
    window.criteo_q.push({
        event: "setAccount",
        account: 83964
    }, {
        event: "setEmail",
        email: ""
    }, {
        event: "setSiteType",
        type: deviceType
    }, {
        event: "viewHome"
    });
};
var listing = function(param) {
    var start = param.start, end = param.end, kisi = param.kisi, d = param.d;
    window.criteo_q = window.criteo_q || [];
    var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
    window.criteo_q.push({
        event: "setAccount",
        account: 83964
    }, {
        event: "setEmail",
        email: ""
    }, {
        event: "setSiteType",
        type: deviceType
    }, {
        event: "viewSearch",
        din: start ? start : "",
        dout: end ? end : "",
        nbra: kisi ? kisi : "",
        nbrc: 0,
        nbri: 0,
        nbrr: 1
    }, {
        event: "viewList",
        item: d
    });
};
var detail = function(id) {
    window.criteo_q = window.criteo_q || [];
    var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
    window.criteo_q.push({
        event: "setAccount",
        account: 83964
    }, {
        event: "setEmail",
        email: ""
    }, {
        event: "setSiteType",
        type: deviceType
    }, {
        event: "viewItem",
        item: id
    });
};
var sendReservation = function(email, reservationdate1, reservationdate2, kisi, id, price) {
    window.criteo_q = window.criteo_q || [];
    var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
    window.criteo_q.push({
        event: "setAccount",
        account: 83964
    }, {
        event: "setEmail",
        email: email
    }, {
        event: "setSiteType",
        type: deviceType
    }, {
        event: "viewSearch",
        din: reservationdate1,
        dout: reservationdate2,
        nbra: kisi,
        nbrc: 0,
        nbri: 0,
        nbrr: 1
    }, {
        event: "trackTransaction",
        id: id,
        item: [
            {
                id: id,
                price: price,
                quantity: 1
            }
        ]
    });
};
var payment = function(email, tarih, tarih2, yetiskin, cocuk, id, productId, price) {
    window.criteo_q = window.criteo_q || [];
    var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
    window.criteo_q.push({
        event: "setAccount",
        account: 83964
    }, {
        event: "setEmail",
        email: email
    }, {
        event: "setSiteType",
        type: deviceType
    }, {
        event: "viewSearch",
        din: tarih,
        dout: tarih2,
        nbra: yetiskin,
        nbrc: cocuk,
        nbri: 0,
        nbrr: 1
    }, {
        event: "trackTransaction",
        id: id,
        item: [
            {
                id: productId,
                price: price,
                quantity: 1
            }
        ]
    });
};


/***/ }),

/***/ 89507:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var theme = {
    "theme-first": {
        logo: "/icons/logo.svg",
        headerLogoClass: "w-[184px] h-9 lg:w-[232px] lg:h-[45px]",
        brandcolorsecondary: "bg-brand-color-secondary",
        toBrand7: "to-brand-gray-7",
        bgDetailInfo: "bg-primary",
        colorContent: "text-[#0774a5]",
        blogBg: "bg-[#0076aa]",
        textBlog: "text-green-400",
        LastMinute: {
            WrapperClass: ""
        },
        header: {
            borderClass: ""
        },
        footerLogoWidth: 258,
        footerBgLogo: "lg:bg-footerBgCircle",
        storyItemBorderColor: "",
        FooterBanner: true,
        DetailVideoBgClass: "bg-brand-color-secondary text-white"
    },
    "theme-second": {
        logo: "/icons/logo2.svg",
        headerLogoClass: "w-[184px] lg:w-[232px] h-[86px]",
        toBrand7: "",
        brandcolorsecondary: "bg-brand-color-primary",
        bgDetailInfo: "bg-primary",
        colorContent: "text-[#ee3b29]",
        blogBg: "bg-[#ed4029]",
        textBlog: "text-black",
        LastMinute: {
            WrapperClass: "mt-3"
        },
        header: {
            borderClass: "bOrderx"
        },
        footerLogoWidth: 140,
        footerBgLogo: "",
        storyItemBorderColor: "border-[#f5d3d9]",
        FooterBanner: false,
        DetailVideoBgClass: "bg-white"
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (theme["theme-first"]);


/***/ }),

/***/ 98015:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__DzzeO","Wrapper":"Header_Wrapper__DblDi","header-menu-height":"Header_header-menu-height__UK_NK"};

/***/ }),

/***/ 34714:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 89966:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 40906:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90638)


/***/ }),

/***/ 25675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(28045)


/***/ }),

/***/ 41664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(48418)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20699)


/***/ }),

/***/ 41799:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectSpread; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 84849:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Skeleton; }
/* harmony export */ });
/* unused harmony export SkeletonTheme */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/**
 * @internal
 */
const SkeletonThemeContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext({});

/* eslint-disable react/no-array-index-key */
const defaultEnableAnimation = true;
// For performance & cleanliness, don't add any inline styles unless we have to
function styleOptionsToCssProperties({ baseColor, highlightColor, width, height, borderRadius, circle, direction, duration, enableAnimation = defaultEnableAnimation, }) {
    const style = {};
    if (direction === 'rtl')
        style['--animation-direction'] = 'reverse';
    if (typeof duration === 'number')
        style['--animation-duration'] = `${duration}s`;
    if (!enableAnimation)
        style['--pseudo-element-display'] = 'none';
    if (typeof width === 'string' || typeof width === 'number')
        style.width = width;
    if (typeof height === 'string' || typeof height === 'number')
        style.height = height;
    if (typeof borderRadius === 'string' || typeof borderRadius === 'number')
        style.borderRadius = borderRadius;
    if (circle)
        style.borderRadius = '50%';
    if (typeof baseColor !== 'undefined')
        style['--base-color'] = baseColor;
    if (typeof highlightColor !== 'undefined')
        style['--highlight-color'] = highlightColor;
    return style;
}
function Skeleton({ count = 1, wrapper: Wrapper, className: customClassName, containerClassName, containerTestId, circle = false, style: styleProp, ...originalPropsStyleOptions }) {
    var _a, _b, _c;
    const contextStyleOptions = react__WEBPACK_IMPORTED_MODULE_0__.useContext(SkeletonThemeContext);
    const propsStyleOptions = { ...originalPropsStyleOptions };
    // DO NOT overwrite style options from the context if `propsStyleOptions`
    // has properties explicity set to undefined
    for (const [key, value] of Object.entries(originalPropsStyleOptions)) {
        if (typeof value === 'undefined') {
            delete propsStyleOptions[key];
        }
    }
    // Props take priority over context
    const styleOptions = {
        ...contextStyleOptions,
        ...propsStyleOptions,
        circle,
    };
    // `styleProp` has the least priority out of everything
    const style = {
        ...styleProp,
        ...styleOptionsToCssProperties(styleOptions),
    };
    let className = 'react-loading-skeleton';
    if (customClassName)
        className += ` ${customClassName}`;
    const inline = (_a = styleOptions.inline) !== null && _a !== void 0 ? _a : false;
    const elements = [];
    const countCeil = Math.ceil(count);
    for (let i = 0; i < countCeil; i++) {
        let thisStyle = style;
        if (countCeil > count && i === countCeil - 1) {
            // count is not an integer and we've reached the last iteration of
            // the loop, so add a "fractional" skeleton.
            //
            // For example, if count is 3.5, we've already added 3 full
            // skeletons, so now we add one more skeleton that is 0.5 times the
            // original width.
            const width = (_b = thisStyle.width) !== null && _b !== void 0 ? _b : '100%'; // 100% is the default since that's what's in the CSS
            const fractionalPart = count % 1;
            const fractionalWidth = typeof width === 'number'
                ? width * fractionalPart
                : `calc(${width} * ${fractionalPart})`;
            thisStyle = { ...thisStyle, width: fractionalWidth };
        }
        const skeletonSpan = (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: className, style: thisStyle, key: i }, "\u200C"));
        if (inline) {
            elements.push(skeletonSpan);
        }
        else {
            // Without the <br />, the skeleton lines will all run together if
            // `width` is specified
            elements.push(react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { key: i },
                skeletonSpan,
                react__WEBPACK_IMPORTED_MODULE_0__.createElement("br", null)));
        }
    }
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", { className: containerClassName, "data-testid": containerTestId, "aria-live": "polite", "aria-busy": (_c = styleOptions.enableAnimation) !== null && _c !== void 0 ? _c : defaultEnableAnimation }, Wrapper
        ? elements.map((el, i) => react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, { key: i }, el))
        : elements));
}

function SkeletonTheme({ children, ...styleOptions }) {
    return (React.createElement(SkeletonThemeContext.Provider, { value: styleOptions }, children));
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [49774,40179], function() { return __webpack_exec__(91118), __webpack_exec__(90387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);